import React, { Component } from "react";
import ReactDOM from "react-dom";
import { EventEmitter } from "eventemitter3";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import BunkeyAPI from "../../api/BunkeyAPI";
import moment from "moment";
import { Link } from "react-router-dom";
import fileextension from "file-extension";
import DocumentView from "../document-view/DocumentView";
import PDFViewContainer from "../pdf-view/PDFViewContainer";
import VideoView from "../assets-view/VideoView";
import PointIndicator from "../point-indicator/PointIndicator";
import { SVGView } from "../assets-view/SVGView";
import { KEY_CODE_ESC, KEY_CODE_ENTER } from "../../utils";
import { SUCCESS_STATUS } from "../../utils/Constants/DocumentConstants";

import {
  hideComment,
  consultCommentDetermined,
  showHideVersions,
  hideVersions,
  handleShowHideEmoji,
  createComment,
  getComments,
  swapVersion,
  showComment,
  showCompareVersions,
  hideVersionsAndCompareVersions,
  setSelectedItem,
  deleteCommentDetermined,
  saveCommentDetermined,
  deleteVersions,
  deleteComment,
  clearFocusDecription,
  updateComment,
  setPDFCarouselIndex,
  unsetIsPdfTagActive,
  unsetIsImageTagActive,
  unsetIsVideoTagActive,
  unsetIsAudioTagActive,
  setIsImageTagActive,
  checkAsset,
  showVersionHasChangedMessage
} from "../../actions/CommentAction";
import { Tooltip, Icon } from "antd";
import { getSearchResult } from "../../actions/SearchAction";
import {
  updateClientes,
  createClientMedia,
  createClientStatus,
  deleteClientMedia,
  deleteClientStatus,
  setEditAsset,
  setSelectItem,
  handleShowNewVersionAsset
} from "../../actions/ClientAction";
import { getClientsByName } from "../../actions/ClientsAction";
import {
  getNewPermission,
  sendNotification,
  isMediaActive,
  handleSetSrc,
  isDefaultAssetPath
} from "../../utils/index";
import { TextEditorDart } from "./TextEditorDart";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "./emoji-mart.css";
import "./dart_internal.css";
import { AUDIO_EXT } from "../../utils";
import AudioView from "../assets-view/AudioView";
import { CirclePicker } from "react-color";
import AssetMedia from "./AssetMedia";
import Magnifier from "react-magnifier";

import TagDart from "./TagDart";
import ClipLoader from "react-spinners/BeatLoader";
import MainVersionsTop from "./MainVersionsTop";
import MainVersionsList from "./MainVersionsList";
import CompareVersion from "./CompareVersion/CompareVersion2";
import AssetConvertinatorStatusView from "./AssetConvertinatorStatusView/AssetConvertinatorStatusView";
import VersionAsset3 from "../upload/VersionAsset3";
import MainCommentsTopv2 from "./MainCommentsTopv2";
import MainCommentsListv2 from "./MainCommentsListv2";
import RightButtonsV2 from "./RightButtonsV2";
import MainFilesList from "./MainFilesList";

export const eventBus = new EventEmitter();

export class Main2 extends Component {
  constructor(props) {
    super(props);
    this.descriptionRef = React.createRef();
    this.archiveBlockRef = React.createRef();
    this.state = {
      breadCrumbs: [],
      theme: 1,
      isItemSelected: null,
      canViewVersionsDart: false,
      canCreateVersionDart: false,
      canEditDescriptionDart: false,
      canEditStatesDart: false,
      canEditMediaDart: false,
      canCreateCommentDart: false,
      defaultAvatar: "/images/icons/user-icon.svg",
      recommendedText: false,
      recommendedTextAnswer: false,
      saveRecommendedText: false,
      comment: "",
      commentLoading: "",
      searchComments: "",
      filtersComments: [],
      idSelectVersion: null,
      idDeleteVersion: null,
      mediaIdToDelete: null,
      statusIdToDelete: null,
      showModalSelectVersion: false,
      showModalDeleteVersion: false,
      showModalDeleteMedia: false,
      showModalDeleteStatus: false,
      isShowCompareVersion: false,
      isShowComments: false,
      isShowVersions: false,
      isShowViewFile: false,
      itemsVersionsForCompare: [],
      showStatusAssets: false,
      answerComments: {
        show: false,
        answer: "",
        commentId: null
      },
      showPickerEmoji: {
        show: false,
        isMain: true,
        commentId: null
      },
      modalCreateMedia: false,
      modalCompareVersion: false,
      itemsComments: [],
      isMainComment: 0,
      isFocusDescription: false,
      statusAssetCreate: false,
      mediaColorState: "#673AB7",
      statusColorState: "#673AB7",
      showColorPicker: false,
      mediaName: "",
      statusName: "",
      selectedMediaIcon: "global",
      mediaList: [
        "global",
        "twitter",
        "message",
        "google",
        "google-plus",
        "linkedin",
        "slack",
        "skype",
        "reddit",
        "account-book",
        "alert",
        "api",
        "appstore",
        "audio",
        "bank",
        "bell",
        "book",
        "box-plot",
        "bug",
        "build",
        "bulb",
        "calculator",
        "calendar",
        "camera",
        "car",
        "carry-out",
        "check-circle",
        "check-square",
        "clock-circle",
        "close-circle",
        "close-square",
        "cloud",
        "code",
        "compass",
        "container",
        "control",
        "copy",
        "credit-card",
        "crown",
        "customer-service",
        "dashboard",
        "database",
        "delete",
        "diff",
        "dislike",
        "down-circle",
        "file-word",
        "file-zip",
        "file",
        "filter",
        "fire",
        "flag",
        "folder-add",
        "folder-open",
        "folder",
        "frown",
        "fund",
        "funnel-plot",
        "gift",
        "gold",
        "hdd",
        "heart",
        "highlight",
        "home",
        "hourglass",
        "html5",
        "idcard",
        "info-circle",
        "insurance",
        "interaction",
        "layout",
        "left-circle",
        "left-square",
        "like",
        "lock",
        "mail",
        "medicine-box",
        "meh",
        "minus-circle",
        "minus-square",
        "mobile",
        "money-collect",
        "notification",
        "pause-circle",
        "phone",
        "picture",
        "pie-chart",
        "play-circle"
      ],
      selectedStatusIcon: "query",
      statusList: [
        "query",
        "goodhand",
        "view",
        "wait",
        "exclamation",
        "like",
        "notification",
        "cancel",
        "other",
        "global",
        "twitter",
        "message",
        "google",
        "google-plus",
        "linkedin",
        "slack",
        "skype",
        "reddit",
        "account-book",
        "alert-2",
        "api",
        "appstore",
        "audio",
        "bank",
        "bell",
        "book",
        "box-plot",
        "bug",
        "build",
        "bulb",
        "calculator",
        "calendar",
        "camera",
        "car",
        "carry-out",
        "check-circle",
        "check-square",
        "clock-circle",
        "close-circle",
        "close-square",
        "cloud",
        "code",
        "compass",
        "container",
        "control",
        "copy",
        "credit-card",
        "crown",
        "customer-service",
        "dashboard",
        "database",
        "delete",
        "diff",
        "dislike",
        "down-circle",
        "file-word",
        "file-zip",
        "file",
        "filter",
        "fire",
        "flag",
        "folder-add",
        "folder-open",
        "folder",
        "frown",
        "fund",
        "funnel-plot",
        "gift",
        "gold",
        "hdd",
        "heart",
        "highlight",
        "home",
        "hourglass",
        "html5",
        "idcard",
        "info-circle",
        "insurance",
        "interaction",
        "layout",
        "left-circle",
        "left-square",
        "lock",
        "mail",
        "medicine-box",
        "meh",
        "minus-circle",
        "minus-square",
        "mobile",
        "money-collect",
        "notification-2",
        "pause-circle",
        "phone",
        "picture",
        "pie-chart",
        "play-circle"
      ],
      showTimes: false,
      opviews: new Map([
        ["FILES", 0],
        ["COMMENTS", 1],
        ["VERSIONS", 2],
        ["COMPARE_VERSIONS", 3],
        ["VIEW_FILE", 4]
      ]),
      mentions: [],
      mentionsAnswer: [],
      showModalDeleteComment: false,
      commentDelete: null,
      isAlreadyScrollToComment: false,
      viewerCompare: {
        show: false,
        src: null
      }
    };
    this.videoTimeRef2 = React.createRef();

    this.changeFocusDescription = this.changeFocusDescription.bind(this);
  }

  componentDidMount() {
    const { itemSelected, user, newMatrix, avatar, showVersions } = this.props;

    document.addEventListener("keydown", this.handleKeyPress, { once: false });

    if (showVersions) {
      this.setState({
        isShowVersions: true
      });
    } else
      this.setState({
        isShowComments: true
      });

    if (avatar) {
      this.setState({
        defaultAvatar: avatar
      });
    }

    if (itemSelected && itemSelected.document) {
      // Si hay asset seleccionado se considera si listComments viene abierto o cerrado
      this.setState({
        isItemSelected: true,
        canViewVersionsDart:
          user.clientRole === "admin" ||
          user.role === "admin" ||
          getNewPermission(
            itemSelected.document._id,
            newMatrix,
            "viewVersionsDart"
          )
      });

      if (Object.entries(itemSelected).length > 0) {
        this.handleGetPathItem();
      }
    } else {
      // Si no hay asset seleccionado lista de comentarios siempre se empezará abierta
      this.setState({
        isItemSelected: false
      });
    }
    this.props.consultCommentDetermined();

    if (itemSelected && itemSelected.comments) {
      this.setState({
        itemsComments: itemSelected.comments.sort(function(a, b) {
          return new Date(b.createdAt) - new Date(a.createdAt);
        })
      });
    }
    this.props.unsetIsPdfTagActive();
    this.props.unsetIsImageTagActive();
    this.props.unsetIsVideoTagActive();
    this.props.unsetIsAudioTagActive();
  }

  componentDidUpdate(prevProps) {
    const {
      itemSelected,
      versionsShowCompare,
      user,
      newMatrix,
      itemSelectedFetching,
      setPDFCarouselIndex
    } = this.props;
    if (
      prevProps.itemSelected &&
      prevProps.itemSelected.document &&
      itemSelected &&
      itemSelected.document &&
      prevProps.itemSelected.document._id !== itemSelected.document._id
    )
      setPDFCarouselIndex(1);

    if (
      prevProps.itemSelectedFetching !== itemSelectedFetching &&
      itemSelected.document
    ) {
      this.handleGetPathItem();
    }

    if (prevProps.itemSelected !== itemSelected) {
      if (itemSelected && itemSelected.document) {
        this.setState({
          itemsVersionsForCompare: [],
          isItemSelected: true,
          canViewVersionsDart:
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(
              itemSelected.document._id,
              newMatrix,
              "viewVersionsDart"
            ),
          canCreateVersionDart:
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(
              itemSelected.document._id,
              newMatrix,
              "createVersionDart"
            ),
          canEditDescriptionDart:
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(
              itemSelected.document._id,
              newMatrix,
              "editDescriptionDart"
            ),

          canEditStatesDart:
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(
              itemSelected.document._id,
              newMatrix,
              "editStatesDart"
            ),

          canEditMediaDart:
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(
              itemSelected.document._id,
              newMatrix,
              "editMediaDart"
            ),

          canCreateCommentDart:
            user.clientRole === "admin" ||
            user.role === "admin" ||
            getNewPermission(
              itemSelected.document._id,
              newMatrix,
              "createCommentDart"
            )
        });
      } else {
        this.setState({
          isItemSelected: false,
          canViewVersionsDart: false
        });
      }
    }

    if (
      prevProps.versionsShowCompare !== versionsShowCompare &&
      versionsShowCompare
    ) {
      document.removeEventListener("keydown", this.handleKeyPress, {
        once: false
      });
    }

    if (
      itemSelected.comments &&
      prevProps.itemSelected.comments !== itemSelected.comments
    ) {
      this.setState({
        itemsComments: itemSelected.comments.sort(function(a, b) {
          return new Date(b.createdAt) - new Date(a.createdAt);
        })
      });
    }

    if (this.props.focusDescription) {
      setTimeout(() => {
        if (this.descriptionRef.current) {
          const dataScrollView = this.descriptionRef.current.getBoundingClientRect();
          this.archiveBlockRef.current.scroll({
            top: dataScrollView.top + 250,
            behavior: "smooth"
          });
          this.props.clearFocusDecription();
        }
      }, 2200);
    }
  }

  handleGetPathItem = () => {
    const { itemSelected, breadcrumb, user, newMatrix } = this.props;

    let route = [];
    if (itemSelected.document.parents && breadcrumb) {
      itemSelected.document.parents.forEach(itemParents => {
        breadcrumb.forEach(breadElement => {
          if (itemParents === breadElement._id)
            route.push({ id: breadElement._id, name: breadElement.name });
        });
      });

      this.setState({
        breadCrumbs: route,
        canCreateVersionDart:
          user.clientRole === "admin" ||
          user.role === "admin" ||
          getNewPermission(
            itemSelected.document._id,
            newMatrix,
            "createVersionDart"
          ),
        canViewVersionsDart:
          user.clientRole === "admin" ||
          user.role === "admin" ||
          getNewPermission(
            itemSelected.document._id,
            newMatrix,
            "viewVersionsDart"
          ),
        canEditDescriptionDart:
          user.clientRole === "admin" ||
          user.role === "admin" ||
          getNewPermission(
            itemSelected.document._id,
            newMatrix,
            "editDescriptionDart"
          ),

        canEditStatesDart:
          user.clientRole === "admin" ||
          user.role === "admin" ||
          getNewPermission(
            itemSelected.document._id,
            newMatrix,
            "editStatesDart"
          ),

        canEditMediaDart:
          user.clientRole === "admin" ||
          user.role === "admin" ||
          getNewPermission(
            itemSelected.document._id,
            newMatrix,
            "editMediaDart"
          ),

        canCreateCommentDart:
          user.clientRole === "admin" ||
          user.role === "admin" ||
          getNewPermission(
            itemSelected.document._id,
            newMatrix,
            "createCommentDart"
          )
      });
    }
  };

  handleKeyPress = e => {
    const { intl } = this.props;
    switch (e.keyCode) {
      case KEY_CODE_ESC:
        this.props.hideComment(intl);
        break;
      default:
        break;
    }
  };

  handleOnClickOpacity = () => {
    const { intl } = this.props;
    this.props.hideComment(intl);
  };

  handleHideVersions = () => {
    this.props.hideVersions();
  };

  handleTagSearch = r => {
    const { workclient, intl } = this.props;

    if (workclient) {
      this.props.getSearchResult(workclient, `"${r}"`, "all");
      this.props.hideComment(intl);
    } else {
      this.props.getClientsByName(1, r);
      this.props.hideComment(intl);
    }
  };

  /**COMMENTS */
  handleKeyDown = e => {
    const { saveRecommendedText, comment } = this.state;
    if (!e.shiftKey) {
      if (
        e.keyCode === KEY_CODE_ENTER &&
        !saveRecommendedText &&
        comment.trim()
      ) {
        e.preventDefault();
        this.handleSubmit();
      }
      if (e.keyCode === KEY_CODE_ENTER && saveRecommendedText) {
        this.handleSaveRecommendedText();
      }
    }
  };

  handleSubmit = (fileToSend = null, fileTag = null) => {
    const { comment, mentions } = this.state;
    const {
      itemSelected,
      workclient,
      user,
      reply,
      unsetIsPdfTagActive,
      // unsetIsAudioTagActive,
      // isAudioTagActive,
      isPdfTagActive,
      // isImageTagActive,
      // isVideoTagActive,
      intl,
      showVersionHasChangedMessage
    } = this.props;
    let finalComment = "";
    let finalMentions = [];

    // let time = this.videoTimeRef2.current;

    if (
      (itemSelected && comment && comment.length > 0) ||
      (itemSelected && fileToSend)
    ) {
      finalComment = comment;

      const item = {
        position: reply ? reply.position + 1 : 1,
        numberReply: reply ? reply._id : null,
        versionId: null
      };

      finalMentions = mentions
        .filter(r => finalComment.indexOf(`@[${r.display}](${r.id})`) > -1)
        .map(r => {
          if (finalComment.indexOf(`@[${r.display}](${r.id})`) > -1) {
            finalComment = finalComment.replace(
              `@[${r.display}](${r.id})`,
              r.display
            );
            return {
              user: r.id,
              nickName: r.display
            };
          }
          return null;
        });

      if (fileTag) {
        checkAsset(
          workclient,
          itemSelected.document._id,
          itemSelected.document.uuid
        ).then(isCurrentAssetByUUID => {
          if (isCurrentAssetByUUID) {
            const timeVideo = fileTag && fileTag.videoTime ? fileTag.videoTime : null
            const timeAudio = fileTag && fileTag.audioTime ? fileTag.audioTime : null
            this.props.createComment(
              itemSelected.document._id,
              item.position,
              item.numberReply,
              finalComment,
              user._id,
              item.versionId,
              workclient,
              finalMentions,
              undefined,
              fileToSend,
              fileTag,
              timeVideo ? timeVideo : timeAudio ? timeAudio : null
            );

            this.setState({ comment: "", mentions: [] });
            if (isPdfTagActive) {
              unsetIsPdfTagActive();
            }
            // if (isImageTagActive) {
            //   unsetIsImageTagActive()
            // }
            // if (isVideoTagActive) {
            //   unsetIsVideoTagActive()
            // }
            // if (isAudioTagActive) {
            //   unsetIsAudioTagActive();
            // }
          } else {
            showVersionHasChangedMessage(intl);
          }
        });
      } else {
        this.props.createComment(
          itemSelected.document._id,
          item.position,
          item.numberReply,
          finalComment,
          user._id,
          item.versionId,
          workclient,
          finalMentions,
          undefined,
          fileToSend,
          fileTag
          // time
        );

        this.setState({
          comment: "",
          mentions: []
        });
        if (isPdfTagActive) {
          unsetIsPdfTagActive();
        }
        // if (isImageTagActive) {
        //   unsetIsImageTagActive();
        // }
        // if (isAudioTagActive) {
        //   unsetIsAudioTagActive();
        // }
      }
    }
  };

  updateRefValue = time => {
    this.videoTimeRef2.current = time;
  };

  handleCommentTextChange = e => {
    this.setState({
      comment: e.target.value,
      isMainComment: 1
    });
  };

  addEmojiToComment = item => {
    this.setState(state => ({
      comment: `${state.comment} ${item.native} `,
      showPickerEmoji: {
        ...state.showPickerEmoji,
        show: false
      }
    }));
  };

  selectRecommendedText = (item, isMain) => {
    if (isMain) {
      this.setState({
        comment: item.message || item
      });
    } else {
      this.setState(state => ({
        answerComments: {
          ...state.answerComments,
          answer: item.message || item
        }
      }));
      this.commentRefAnswer.focus();
    }
  };

  deleteRecommendedText = r => {
    const { userDefaultComments } = this.props;
    this.props.deleteCommentDetermined(r._id);
    if (userDefaultComments.length === 1)
      this.setState({
        recommendedText: false
      });
  };

  handleSaveRecommendedText = () => {
    const { comment } = this.state;
    const { workclient, userDefaultComments, intl } = this.props;
    const arr = userDefaultComments.find(
      r => r.message === comment.toLocaleLowerCase()
    );
    if (arr) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "exist_text_recommend" })
      );
    } else {
      this.props.saveCommentDetermined(workclient, comment);
    }
    this.setState({
      comment: "",
      saveRecommendedText: false
    });
  };

  showRecommendedText = (isMain = true) => {
    const { recommendedText, recommendedTextAnswer } = this.state;
    const { userDefaultComments, intl } = this.props;
    if (isMain) {
      if (
        !recommendedText &&
        (!userDefaultComments || userDefaultComments.length === 0)
      ) {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "empty_text_recommend" })
        );
      } else
        this.setState({
          recommendedText: !recommendedText
        });
    } else {
      if (
        !recommendedTextAnswer &&
        (!userDefaultComments || userDefaultComments.length === 0)
      ) {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "empty_text_recommend" })
        );
      } else
        this.setState({
          recommendedTextAnswer: !recommendedTextAnswer
        });
    }
  };

  showSaveRecommendedText = () => {
    this.setState(state => ({
      saveRecommendedText: !state.saveRecommendedText
    }));
  };

  searchCommentsFilters = e => {
    this.setState({
      searchComments: e.target.value
    });
  };

  handleDeleteComment = item => {
    this.props.deleteComment(item._id);
    this.setState({
      showModalDeleteComment: false
    });
  };

  handleShowModalDeleteComment = (op, comment = null) => {
    this.setState({
      showModalDeleteComment: op,
      commentDelete: op ? comment : null
    });
  };

  handleSetCurrentVersion(versionId) {
    const { itemSelected, user, workclient, intl } = this.props;
    this.props.swapVersion(versionId, null, true, itemSelected.document);

    const versionNew = itemSelected.versions.find(
      v => v._id.toString() === versionId
    );

    //Creamos el comentario informativo
    this.props.createComment(
      itemSelected.document._id,
      -1,
      null,
      intl.formatMessage(
        {
          id: "swap_version_asset"
        },
        {
          version_old: itemSelected.document.versionNumber,
          version_y: versionNew ? versionNew.versionNumber : "n/a"
        }
      ),
      user._id,
      null,
      workclient,
      [],
      2 //type
    );
  }

  handleDeleteVersion(versionId) {
    this.props.deleteVersions(versionId);
  }

  editDescriptionAsset = description => {
    const {
      _id,
      name,
      metadata,
      description: __description
    } = this.props.itemSelected.document;
    const { workclient, user, intl } = this.props;
    this.props.setEditAsset(
      "assetsRoot",
      workclient,
      {
        _id,
        name,
        metadata,
        description
      },
      { intl, user, isOldDescription: __description ? !__description : false }
    );
  };

  changeFocusDescription(op) {
    const { canEditDescriptionDart } = this.state;
    if (!canEditDescriptionDart) return;
    this.setState({
      isFocusDescription: op
    });
  }

  showSelectVersion = id => {
    this.setState({
      showModalSelectVersion: true,
      showModalDeleteVersion: false,
      idSelectVersion: id
    });
  };

  hideSelectVersion = () => {
    this.setState({
      showModalSelectVersion: false,
      idSelectVersion: null
    });
  };

  showDeleteVersion = id => {
    this.setState({
      showModalDeleteVersion: true,
      showModalSelectVersion: false,
      idDeleteVersion: id
    });
  };

  hideDeleteVersion = () => {
    this.setState({
      showModalDeleteVersion: false,
      idDeleteVersion: null
    });
  };

  setSelectVersion = () => {
    const { idSelectVersion } = this.state;
    this.handleSetCurrentVersion(idSelectVersion);
    this.setState({
      showModalSelectVersion: false,
      idSelectVersion: null
    });
  };

  deleteVersion = () => {
    const { itemSelected, user, workclient, intl } = this.props;
    const { idDeleteVersion } = this.state;
    this.handleDeleteVersion(idDeleteVersion);

    const versionDelete = itemSelected.versions.find(
      v => v._id.toString() === idDeleteVersion
    );

    this.props.createComment(
      itemSelected.document._id,
      -1,
      null,
      intl.formatMessage(
        {
          id: "delete_version_asset"
        },
        {
          version_x: versionDelete ? versionDelete.versionNumber : "n/a"
        }
      ),
      user._id,
      null,
      workclient,
      [],
      2 //type
    );

    this.setState({
      showModalDeleteVersion: false,
      idDeleteVersion: null
    });
  };

  deleteMedia = () => {
    const { mediaIdToDelete } = this.state;
    this.handleDeleteMedia(mediaIdToDelete);
    this.setState({
      showModalDeleteMedia: false,
      mediaIdToDelete: null
    });
  };

  deleteStatus = () => {
    const { statusIdToDelete } = this.state;
    this.handleDeleteStatus(statusIdToDelete);
    this.setState({
      showModalDeleteStatus: false,
      statusIdToDelete: null
    });
  };

  showDeleteMedia = id => {
    this.setState({
      showModalDeleteMedia: true,
      showModalDeleteVersion: false,
      showModalSelectVersion: false,
      mediaIdToDelete: id
    });
  };

  showDeleteStatus = id => {
    this.setState({
      showModalDeleteStatus: true,
      showModalDeleteMedia: false,
      showModalDeleteVersion: false,
      showModalSelectVersion: false,
      statusIdToDelete: id
    });
  };

  showOrHideViews = op => {
    this.setState(({ opviews }) => ({
      isShowFiles: op === opviews.get("FILES"),
      isShowCompareVersion: op === opviews.get("COMPARE_VERSIONS"),
      isShowComments: op === opviews.get("COMMENTS"),
      isShowVersions: op === opviews.get("VERSIONS"),
      isShowViewFile: op === opviews.get("VIEW_FILE")
    }));
  };
  showCommentComponent = () => this.showOrHideViews(1);

  addItemsForCompare = itemId => {
    const { itemsVersionsForCompare } = this.state;
    const { intl } = this.props;

    if (
      itemsVersionsForCompare.length === 2 &&
      !itemsVersionsForCompare.includes(itemId)
    ) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "max_two_asset" })
      );
    } else {
      if (itemsVersionsForCompare.includes(itemId.toString())) {
        let temp = [...itemsVersionsForCompare];
        temp.splice(temp.indexOf(itemId.toString()), 1);
        this.setState({
          itemsVersionsForCompare: temp
        });
      } else {
        this.setState({
          itemsVersionsForCompare: [
            ...itemsVersionsForCompare,
            itemId.toString()
          ]
        });
      }
    }
  };

  showModalCompareVersion = op => {
    const { itemsVersionsForCompare } = this.state;
    const { intl } = this.props;

    if (itemsVersionsForCompare.length > 1) {
      this.setState(
        {
          modalCompareVersion: op
        },
        () => {
          if (op) {
            ReactDOM.findDOMNode(this.refs.divarchivegrid).focus();
          } else {
            this.setState({ itemsVersionsForCompare: [] });
          }
        }
      );

      BunkeyAPI({
        url: `assetVersion/versionCompare`,
        method: "GET"
      })
        .then(resp => {
          if (resp.status === 200) {
            console.log(resp);
          }
        })
        .catch(err => {
          console.log("mount err: ", err);
        });
      //alert("se ag ejecutaedo")
    } else
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "select_two_asset" })
      );
  };

  showViewerCompareVersion = (op, src = null) => {
    this.setState({
      viewerCompare: {
        show: op,
        src
      }
    });
  };

  moveAssetExplorer = type => {
    const { data, itemSelected, intl } = this.props;
    const dataIds = data
      .filter(d => d.type !== "folder")
      .map(d => d._id.toString());
    const position = dataIds.indexOf(itemSelected.document._id.toString());
    if (position === -1) {
      sendNotification("info", intl, intl.formatMessage({ id: "last_record" }));
      return;
    }
    let newItem = null;
    if (type === "prev") {
      newItem = this.getPrevItem(dataIds, position);
    } else {
      newItem = this.getNextItem(dataIds, position);
    }

    if (newItem) {
      this.props.setSelectedItem(newItem);
    } else {
      sendNotification("info", intl, intl.formatMessage({ id: "last_record" }));
      return;
    }
  };

  getPrevItem = (dataIds, position) => {
    if (dataIds.length === 0 || dataIds.length === 1) return null;
    const newPosition = position - 1 >= 0 ? position - 1 : dataIds.length - 1;
    return dataIds[newPosition];
  };
  getNextItem = (dataIds, position) => {
    if (dataIds.length === 0 || dataIds.length === 1) return null;
    const newPosition = position + 1 > dataIds.length - 1 ? 0 : position + 1;
    return dataIds[newPosition];
  };

  showOrHideStatusAssets = op => {
    this.setState(
      {
        showStatusAssets: op
      },
      () => {
        if (op) {
          ReactDOM.findDOMNode(this.refs.divshowstatus).focus();
        }
      }
    );
  };

  setHtml = html => {
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  };

  setStatusAsset = status => {
    const {
      _id,
      name,
      metadata,
      statusAsset
    } = this.props.itemSelected.document;
    const { workclient, user, intl } = this.props;
    this.setState({
      showStatusAssets: false
    });
    this.props.setEditAsset(
      "assetsRoot",
      workclient,
      {
        _id,
        name,
        metadata,
        statusAsset: status
      },
      { intl, user, statusNew: status, statusOld: statusAsset }
    );
  };

  changeItemsMedia = type => {
    const { _id, name, metadata } = this.props.itemSelected.document;
    const { isUpdating, workclient, user, intl, dartCustomField } = this.props;
    const { canEditMediaDart } = this.state;
    if (!canEditMediaDart || isUpdating) return;
    let media = this.props.itemSelected.document.media
      ? this.props.itemSelected.document.media
      : [];
    const position = media.findIndex(media => {
      if (media.defaultMedia) {
        return media.defaultMediaId === type.defaultMediaId;
      } else {
        return media._id === type._id;
      }
    });

    const infoMedia = {
      nameMedia: type.title,
      enabledMedia:
        media.find(m => m._id.toString() === type._id.toString()) && true
    };

    if (position >= 0) {
      media.splice(position, 1);
      this.props.setEditAsset(
        "assetsRoot",
        workclient,
        {
          _id,
          name,
          metadata,
          media: media,
          typeMedia: type
        },
        { intl, user, titleMedia: dartCustomField, ...infoMedia }
      );
    } else {
      this.props.setEditAsset(
        "assetsRoot",
        workclient,
        {
          _id,
          name,
          metadata,
          media: [...media, type],
          typeMedia: type
        },
        { intl, user, titleMedia: dartCustomField, ...infoMedia }
      );
    }
  };

  handleUpdateMedia = () => {
    const { clientId, media, statusAsset } = this.props;
    const { mediaName, mediaColorState, selectedMediaIcon } = this.state;

    this.setState({
      modalCreateMedia: false,
      mediaName: null
    });

    const itemsMedia = [
      ...media,
      { title: mediaName, color: mediaColorState, type: selectedMediaIcon }
    ];
    this.props.updateClientes(
      clientId,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      itemsMedia,
      statusAsset
    );
  };

  hanleCreateNewMedia = () => {
    const { clientId, intl } = this.props;
    const { mediaName, mediaColorState, selectedMediaIcon } = this.state;
    if (mediaName.trim() === "") {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "add_title_new_stamp" })
      );
    } else {
      const newMedia = {
        title: mediaName,
        color: mediaColorState,
        type: selectedMediaIcon
      };
      this.props.createClientMedia(clientId, newMedia);

      this.setState({
        modalCreateMedia: false,
        mediaName: "",
        selectedMediaIcon: "global",
        mediaColorState: "#673AB7"
      });
    }
  };

  handleCreateStatus = () => {
    const { clientId, intl } = this.props;
    const { statusName, statusColorState, selectedStatusIcon } = this.state;

    if (statusName.trim() === "") {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "add_title_new_stamp" })
      );
    } else {
      const newStatusAsset = {
        title: statusName,
        color: statusColorState,
        type: selectedStatusIcon
      };

      this.props.createClientStatus(clientId, newStatusAsset);

      this.setState({
        statusAssetCreate: false,
        statusName: "",
        selectedStatusIcon: "query",
        statusColorState: "#673AB7"
      });
    }
  };

  handleDeleteMedia = mediaId => {
    const { clientId } = this.props;
    this.props.deleteClientMedia(clientId, mediaId);
  };

  handleDeleteStatus = statusId => {
    const { clientId } = this.props;
    this.props.deleteClientStatus(clientId, statusId);
  };

  showModalMediaCreate = op => {
    this.setState(
      {
        modalCreateMedia: op
      },
      () => {
        if (op) {
          // ReactDOM.findDOMNode(this.refs.divnewmedio).focus();
          // this.newmedio.focus();
        }
      }
    );
  };

  showModalStatusAssetCreate = op => {
    this.setState(
      {
        statusAssetCreate: op
      },
      () => {
        if (op) {
          // ReactDOM.findDOMNode(this.refs.divnewstatus).focus();
          // this.newstatus.focus();
        }
      }
    );
  };

  handleChangeMediaColor = color => {
    this.setState({
      mediaColorState: color.hex,
      showColorPicker: false
    });
  };

  handleChangeStatusColor = color => {
    this.setState({
      statusColorState: color.hex,
      showColorPicker: false
    });
  };

  handleInputOnChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  focusInCurrentTarget = ({ relatedTarget, currentTarget }) => {
    if (relatedTarget === null) return false;
    if (relatedTarget === currentTarget) return true;
    let node = relatedTarget.parentNode;
    while (node !== null) {
      if (node === currentTarget) return true;
      node = node.parentNode;
    }
    return false;
  };

  closeAll = e => {
    if (!this.focusInCurrentTarget(e))
      this.setState(state => ({
        modalCreateMedia: false,
        modalCompareVersion: false,
        statusAssetCreate: false,
        showModalSelectVersion: false,
        recommendedText: false,
        recommendedTextAnswer: false,
        showPickerEmoji: {
          ...state.showPickerEmoji,
          show: false
        },
        itemsVersionsForCompare: []
      }));
  };

  closeStatusAssetsList = e => {
    this.setState({ showStatusAssets: false });
  };

  onAddMention = (id, display) => {
    this.setState(state => ({
      mentions: [...state.mentions.filter(r => r.id !== id), { id, display }]
    }));
  };

  closeRecommendedText = () => {
    this.setState({
      recommendedText: false
    });
  };

  closeModalDeleteMedia = () => {
    this.setState({ showModalDeleteMedia: false });
  };

  closeModalDeleteStatus = () => {
    this.setState({ showModalDeleteStatus: false });
  };

  closeModalDeleteComment = () => {
    this.setState({ showModalDeleteComment: false });
  };

  handleImageClick = (event) => {
    const { itemsComments } = this.state
    const tableRect = event.currentTarget.getBoundingClientRect(); // Get the table's bounding rectangle
    const imgWidth = tableRect.width;
    const imgHeight = tableRect.height;
    const relativeX = event.clientX - tableRect.left; // Calculate relative X position
    const relativeY = event.clientY - tableRect.top; // Calculate relative Y position

    const imageXPer = (relativeX * 100.0) / imgWidth;
    const imageYPer = (relativeY * 100.0) / imgHeight;

    const pointsCommentsImages = itemsComments.filter(el => {
      return el.fileTag && el.fileTag.imagePoint
    })
    const nextIndexPointImage = pointsCommentsImages && pointsCommentsImages.length > 0 ? pointsCommentsImages.length + 1 : 1
    this.props.setIsImageTagActive(imageXPer, imageYPer, nextIndexPointImage, imgWidth, imgHeight);
  };

  render() {
    const hash = "#";
    const {
      canViewVersionsDart,
      breadCrumbs,
      defaultAvatar,
      comment,
      showModalSelectVersion,
      showModalDeleteVersion,
      showModalDeleteMedia,
      showModalDeleteStatus,
      isShowCompareVersion,
      isShowComments,
      isShowVersions,
      itemsVersionsForCompare,
      showStatusAssets,
      recommendedText,
      saveRecommendedText,
      searchComments,
      modalCreateMedia,
      modalCompareVersion,
      mediaColorState,
      statusColorState,
      showColorPicker,
      selectedMediaIcon,
      selectedStatusIcon,
      mediaList,
      statusList,
      mediaName,
      statusName,
      statusAssetCreate,
      opviews,
      canEditStatesDart,
      canEditMediaDart,
      canCreateCommentDart,
      canCreateVersionDart,
      showModalDeleteComment,
      commentDelete,
      viewerCompare,
      itemsComments,
      isShowFiles
    } = this.state;
    const {
      itemSelectedFetching,
      itemSelected,
      intl,
      loadingDescription,
      loadingStatusAsset,
      dartCustomField,
      fromKeyCollection,
      user,
      workclient,
      imageTagXPer,
      imageTagYPer,
      imageTagWidth, 
      imageTagHeight,
      // imagePoint,
      isImageTagActive
    } = this.props;
    const { media, statusAsset } = this.props;
    const st = statusAsset.find(
      s =>
        itemSelected &&
        itemSelected.document &&
        itemSelected.document.statusAsset &&
        s._id === itemSelected.document.statusAsset._id
    );

    let desp = undefined;
    if (
      itemSelected &&
      itemSelected.document &&
      itemSelected.document.description
    ) {
      desp = { ...itemSelected.document.description };
      if (!desp.entityMap) desp = { ...desp, ...{ entityMap: {} } };
    }

    const PREV_ASSET = "prev";
    const NEXT_ASSET = "next";

    const mediaTags = media
      ? media
          .filter(i => {
            const isActive =
              itemSelected.document &&
              itemSelected.document.media &&
              isMediaActive(itemSelected.document.media, i);
            if (!canEditMediaDart && !isActive) {
              return false;
            }
            return true;
          })
          .map((i, k) => {
            const isActive = isMediaActive(itemSelected.document.media, i);

            return (
              <AssetMedia
                key={k}
                isActive={isActive}
                changeItemsMedia={this.changeItemsMedia}
                media={i}
                canEditMediaDart={canEditMediaDart}
                itemSelected={itemSelected}
                showDeleteMedia={this.showDeleteMedia}
                canDeleteMedia={
                  user.clientRole === "admin" || user.role === "admin"
                }
              />
            );
          })
      : [];

    const COLOR_LOADER = "#0E2A45";
    const SIZE_LOADER = 35;

    // console.log("videoTime", videoTime);
    const pointsCommentsImages = itemsComments.filter(el => {
      return el.fileTag && el.fileTag.imagePoint
    })
    if (pointsCommentsImages && pointsCommentsImages.length > 0) {
      pointsCommentsImages.reverse().forEach((el, ind) => {
        if (el.fileTag && el.fileTag.imagePoint) {
          el.fileTag.imagePoint.index = ind + 1
        } 
      })
    }
    const showPointsImages = pointsCommentsImages && pointsCommentsImages.length > 0 ? true : false
    const nextIndexPointImage = pointsCommentsImages && pointsCommentsImages.length > 0 ? pointsCommentsImages.length + 1 : 1
    // console.log('itemSelected ?>',itemSelected);
    // console.log('itemSelectedFetching ?>',itemSelectedFetching);
    return (
      <div>
        {itemSelected && !itemSelected.document && itemSelectedFetching ? (
          <div className="loading-dart">
            <ClipLoader
              loading={true}
              size={SIZE_LOADER}
              color={COLOR_LOADER}
            />
          </div>
        ) : itemSelected && itemSelected.document && !itemSelectedFetching ? (
          <div role="main" className="dart-main">
            <div className="bb-upload">
              <div className="bb-archives-block">
                <div className="block-scroll" style={{ display: "none" }}>
                  <div className="bb-archives-block__top">
                    <div className="bb-archives-block__brand">
                      <img alt="" src="/images/img_v2/upload-head-logo.svg" />
                    </div>
                    <div className="bb-archives-block__pagination">
                      <div className="bb-archives-block__search">
                        <input type="text" placeholder="Buscar archivo" />
                        <div className="bb-archives-block__search-box">
                          <ul>
                            <li>
                              {" "}
                              <a href={hash}>
                                <svg
                                  width={13}
                                  height={13}
                                  viewBox="0 0 13 13"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <rect
                                    width={13}
                                    height={13}
                                    rx="2.4375"
                                    fill="#5167DD"
                                  />
                                  <path
                                    d="M9.24911 6.12814L4.72511 3.46357C4.66986 3.43141 4.61298 3.41211 4.54798 3.41211C4.37086 3.41211 4.22623 3.55684 4.22623 3.73372H4.22461V9.26549H4.22623C4.22623 9.44238 4.37086 9.58711 4.54798 9.58711C4.61461 9.58711 4.66986 9.5646 4.72998 9.53244L9.24911 6.87107C9.35636 6.78263 9.42461 6.64916 9.42461 6.49961C9.42461 6.35006 9.35636 6.2182 9.24911 6.12814Z"
                                    fill="white"
                                  />
                                </svg>
                                Nombre del archivo 1.pdf
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a href={hash}>
                                <svg
                                  width={13}
                                  height={13}
                                  viewBox="0 0 13 13"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <rect
                                    width={13}
                                    height={13}
                                    rx="2.4375"
                                    fill="#0096D6"
                                  />
                                  <path
                                    d="M4 9H3V4H4V9ZM7 2H6V11H7V2ZM10 3.04635H9V10H10V3.04635Z"
                                    fill="white"
                                  />
                                </svg>
                                Nombre del archivo 2.jpg
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a href={hash}>
                                <svg
                                  width={9}
                                  height={13}
                                  viewBox="0 0 9 13"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M3.83564 0.369141H0.891843C0.399292 0.369141 0 0.768028 0 1.26045V11.4666C0 11.9588 0.395596 12.3579 0.886911 12.3579H7.54962C8.03944 12.3579 8.43653 11.9623 8.43653 11.471V5.30141H6.30141C4.93961 5.30141 3.83564 4.19745 3.83564 2.83564V0.369141Z"
                                    fill="#367CE4"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M5.77246 0.369141V3.03201C5.77246 3.27795 5.97271 3.47733 6.21239 3.47733H8.43663L5.77246 0.369141Z"
                                    fill="#367CE4"
                                  />
                                </svg>
                                casa.pdf
                              </a>
                            </li>
                            <li>
                              {" "}
                              <a href={hash}>
                                <svg
                                  width={13}
                                  height={13}
                                  viewBox="0 0 13 13"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2.4375 0C1.09131 0 0 1.09131 0 2.4375V8.12508L5.30004 4.15004C5.63142 3.90152 6.10152 3.96867 6.35004 4.30004L8.83119 7.60824L10.2197 6.21971C10.3706 6.06887 10.5785 5.98939 10.7915 6.00119C11.0045 6.01299 11.2024 6.11494 11.3357 6.28152L13 8.3619V2.4375C13 1.09131 11.9087 0 10.5625 0H2.4375ZM13 9.95738C12.7075 10.0608 12.3692 9.97453 12.1644 9.71856L10.6879 7.87289L9.28037 9.28037C9.12664 9.43411 8.91375 9.51357 8.69688 9.49816C8.48001 9.48274 8.28049 9.37398 8.15004 9.20004L5.60004 5.80004L0.200044 9.85004C0.137498 9.89695 0.0700086 9.93262 0 9.95738V10.5625C0 11.9087 1.09131 13 2.4375 13H10.5625C11.9087 13 13 11.9087 13 10.5625V9.95738Z"
                                    fill="#2EBAD9"
                                  />
                                </svg>
                                Nombre del archivo 1.pdf
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="bb-archives-block__arrows">
                        <Tooltip
                          placement="top"
                          title={intl.formatMessage({ id: "prev_asset" })}
                        >
                          <div
                            className="arrow-prev"
                            onClick={() => this.moveAssetExplorer(PREV_ASSET)}
                          >
                            <svg
                              width={8}
                              height={13}
                              viewBox="0 0 8 13"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7 1L1.27083 6.5L7 12"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        </Tooltip>
                        <Tooltip
                          placement="top"
                          title={intl.formatMessage({ id: "next_asset" })}
                        >
                          <div
                            className="arrow-next"
                            onClick={() => this.moveAssetExplorer(NEXT_ASSET)}
                          >
                            <svg
                              width={8}
                              height={13}
                              viewBox="0 0 8 13"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1 1L6.72917 6.5L1 12"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                  <div className="bb-archives-block__actions">
                    <div className="bb-archives-block__bradcrumb">
                      <ul>
                        <li>
                          <a href={hash}>Bunkey</a>
                        </li>
                        {breadCrumbs.map((r, k) => (
                          <div key={k}>
                            <span>/ </span>
                            <Link
                              to={`/home/explore/${r.id}`}
                              onClick={() => this.props.hideComment(intl)}
                              key={k}
                            >
                              {r.name}
                            </Link>
                          </div>
                        ))}
                      </ul>
                    </div>
                    <h2>Nombre 1510 de archivo</h2>
                    <div className="bb-archives-block__buttons">
                      <div
                        onClick={() =>
                          this.showOrHideViews(opviews.get("COMMENTS"))
                        }
                        className={isShowComments ? "active" : ""}
                      >
                        <svg
                          width={23}
                          height={23}
                          viewBox="0 0 23 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M3.65516 2.33398C3.33662 2.33398 3.03113 2.46052 2.80588 2.68577C2.58064 2.91101 2.4541 3.2165 2.4541 3.53504V18.7293L5.14911 16.0343C5.33665 15.8467 5.591 15.7414 5.85622 15.7414H19.0626C19.3811 15.7414 19.6866 15.6149 19.9118 15.3896C20.1371 15.1644 20.2636 14.8589 20.2636 14.5403V3.53504C20.2636 3.2165 20.1371 2.91101 19.9118 2.68577C19.6866 2.46052 19.3811 2.33398 19.0626 2.33398H3.65516ZM1.39167 1.27155C1.99198 0.671238 2.80619 0.333984 3.65516 0.333984H19.0626C19.9115 0.333984 20.7257 0.671238 21.3261 1.27155C21.9264 1.87187 22.2636 2.68607 22.2636 3.53504V14.5403C22.2636 15.3893 21.9264 16.2035 21.3261 16.8038C20.7257 17.4041 19.9115 17.7414 19.0626 17.7414H6.27043L2.16121 21.8506C1.87521 22.1366 1.44509 22.2222 1.07142 22.0674C0.697744 21.9126 0.454102 21.548 0.454102 21.1435V3.53504C0.454102 2.68607 0.791355 1.87187 1.39167 1.27155Z"
                            fill="#0096D6"
                          />
                        </svg>
                      </div>
                      <div
                        onClick={() =>
                          this.showOrHideViews(opviews.get("COMPARE_VERSIONS"))
                        }
                        className={isShowCompareVersion ? "active" : ""}
                      >
                        <svg
                          width="20"
                          height="24"
                          viewBox="0 0 20 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.3846 5.07692V18.9231C19.3846 19.6575 19.0929 20.3619 18.5735 20.8812C18.0542 21.4006 17.3498 21.6923 16.6154 21.6923H13.3846C13.1398 21.6923 12.905 21.5951 12.7319 21.4219C12.5588 21.2488 12.4615 21.014 12.4615 20.7692C12.4615 20.5244 12.5588 20.2896 12.7319 20.1165C12.905 19.9434 13.1398 19.8462 13.3846 19.8462H16.6154C16.8602 19.8462 17.095 19.7489 17.2681 19.5758C17.4412 19.4027 17.5385 19.1679 17.5385 18.9231V5.07692C17.5385 4.83211 17.4412 4.59732 17.2681 4.42421C17.095 4.2511 16.8602 4.15385 16.6154 4.15385H13.3846C13.1398 4.15385 12.905 4.05659 12.7319 3.88348C12.5588 3.71037 12.4615 3.47558 12.4615 3.23077C12.4615 2.98595 12.5588 2.75117 12.7319 2.57806C12.905 2.40494 13.1398 2.30769 13.3846 2.30769H16.6154C17.3498 2.30769 18.0542 2.59945 18.5735 3.11878C19.0929 3.63811 19.3846 4.34248 19.3846 5.07692ZM10.6154 0.923077V23.0769C10.6154 23.3217 10.5181 23.5565 10.345 23.7296C10.1719 23.9027 9.93712 24 9.69231 24C9.44749 24 9.2127 23.9027 9.03959 23.7296C8.86648 23.5565 8.76923 23.3217 8.76923 23.0769V21.6923H2.76923C2.03479 21.6923 1.33042 21.4006 0.811089 20.8812C0.291757 20.3619 0 19.6575 0 18.9231V5.07692C0 4.34248 0.291757 3.63811 0.811089 3.11878C1.33042 2.59945 2.03479 2.30769 2.76923 2.30769H8.76923V0.923077C8.76923 0.678262 8.86648 0.443473 9.03959 0.270363C9.2127 0.0972524 9.44749 0 9.69231 0C9.93712 0 10.1719 0.0972524 10.345 0.270363C10.5181 0.443473 10.6154 0.678262 10.6154 0.923077ZM8.76923 19.8462V4.15385H2.76923C2.52442 4.15385 2.28963 4.2511 2.11652 4.42421C1.94341 4.59732 1.84615 4.83211 1.84615 5.07692V18.9231C1.84615 19.1679 1.94341 19.4027 2.11652 19.5758C2.28963 19.7489 2.52442 19.8462 2.76923 19.8462H8.76923Z"
                            fill="#0096D6"
                          />
                        </svg>
                      </div>
                      <div
                        onClick={() =>
                          this.showOrHideViews(opviews.get("VERSIONS"))
                        }
                        className={isShowVersions ? "active" : ""}
                      >
                        <svg
                          width={26}
                          height={24}
                          viewBox="0 0 26 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.5976 23.6658C13.345 23.6658 13.1028 23.5654 12.9242 23.3868C12.7456 23.2082 12.6452 22.966 12.6452 22.7134C12.6452 22.4608 12.7456 22.2185 12.9242 22.0399C13.1028 21.8613 13.345 21.761 13.5976 21.761C15.7305 21.7613 17.8018 21.0457 19.4795 19.7287C21.1573 18.4118 22.3444 16.5698 22.8507 14.4979C23.357 12.426 23.1531 10.2441 22.2718 8.30181C21.3905 6.35954 19.8827 4.76933 17.99 3.78598C16.0973 2.80262 13.9294 2.48305 11.8335 2.87847C9.73755 3.27389 7.83504 4.3614 6.43077 5.96677C5.02649 7.57213 4.20175 9.60241 4.08867 11.7323C3.9756 13.8622 4.58075 15.9684 5.80715 17.7134C5.95174 17.9194 6.00887 18.1744 5.96604 18.4224C5.92321 18.6705 5.7839 18.8915 5.57858 19.0372C5.47622 19.1103 5.36039 19.1623 5.23779 19.1904C5.11519 19.2185 4.98825 19.222 4.86428 19.2008C4.74031 19.1795 4.62179 19.1339 4.51554 19.0666C4.40929 18.9993 4.31742 18.9116 4.24525 18.8086C2.77365 16.7147 2.04747 14.1875 2.18305 11.6318C2.31862 9.07608 3.3081 6.63985 4.99296 4.7134C6.67782 2.78695 8.96054 1.48178 11.4754 1.00699C13.9903 0.532206 16.5917 0.915285 18.863 2.09486C21.1342 3.27443 22.9438 5.18221 24.0018 7.51257C25.0599 9.84293 25.3051 12.461 24.6982 14.9473C24.0913 17.4336 22.6674 19.6442 20.6547 21.225C18.642 22.8058 16.1569 23.6653 13.5976 23.6658Z"
                            fill="#0096D6"
                          />
                          <path
                            d="M5.97894 19.8561H1.21703C0.964442 19.8561 0.7222 19.7558 0.543594 19.5772C0.364988 19.3986 0.264648 19.1563 0.264648 18.9037C0.264648 18.6512 0.364988 18.4089 0.543594 18.2303C0.7222 18.0517 0.964442 17.9514 1.21703 17.9514H5.02655V14.1418C5.02655 13.8892 5.12689 13.647 5.3055 13.4684C5.48411 13.2898 5.72635 13.1895 5.97894 13.1895C6.23152 13.1895 6.47376 13.2898 6.65237 13.4684C6.83098 13.647 6.93132 13.8892 6.93132 14.1418V18.9037C6.93132 19.1563 6.83098 19.3986 6.65237 19.5772C6.47376 19.7558 6.23152 19.8561 5.97894 19.8561Z"
                            fill="#0096D6"
                          />
                          <path
                            d="M10.7411 16.0472C10.6158 16.048 10.4915 16.0239 10.3755 15.9766C10.2594 15.9292 10.1539 15.8593 10.0649 15.7711C9.97565 15.6825 9.9048 15.5772 9.85645 15.4611C9.8081 15.3451 9.7832 15.2206 9.7832 15.0949C9.7832 14.9691 9.8081 14.8447 9.85645 14.7286C9.9048 14.6125 9.97565 14.5072 10.0649 14.4187L12.6459 11.8472V7.47582C12.6459 7.22323 12.7462 6.98099 12.9248 6.80238C13.1034 6.62378 13.3457 6.52344 13.5982 6.52344C13.8508 6.52344 14.0931 6.62378 14.2717 6.80238C14.4503 6.98099 14.5506 7.22323 14.5506 7.47582V12.2377C14.5514 12.3631 14.5273 12.4873 14.4799 12.6033C14.4325 12.7194 14.3627 12.8249 14.2744 12.9139L11.4173 15.7711C11.3283 15.8593 11.2228 15.9292 11.1067 15.9766C10.9907 16.0239 10.8664 16.048 10.7411 16.0472Z"
                            fill="#0096D6"
                          />
                        </svg>
                      </div>
                    </div>

                    <div className="bb-archives-block__carrusel">
                      <div className="bb-archives-block__carrusel-big">
                        {/* SE OCULTA  DUPLICADO */}
                        {false && (
                          <figure>
                            {!itemSelectedFetching && itemSelected.document ? (
                              <div>
                                {itemSelected.document.type === "image" &&
                                fileextension(
                                  itemSelected.document.originalURL
                                ) === "svg" ? (
                                  <SVGView
                                    comFromMiddleView={true}
                                    src={itemSelected.document.originalURL}
                                    assetId={itemSelected.document._id}
                                  />
                                ) : itemSelected.document.type === "image" &&
                                  fileextension(
                                    itemSelected.document.originalURL
                                  ) !== "png" ? (
                                  <Magnifier
                                    mgShowOverflow={false}
                                    alt={itemSelected.document.name}
                                    // src={itemSelected.document.mediaQualityURL}
                                    src={handleSetSrc(itemSelected.document)}
                                    className="responsive-img raw_asset_formats"
                                    width={
                                      isDefaultAssetPath(
                                        handleSetSrc(itemSelected.document)
                                      )
                                        ? "50%"
                                        : "100%"
                                    }
                                  />
                                ) : (
                                  itemSelected.document.type === "image" && (
                                    <Magnifier
                                      mgShowOverflow={false}
                                      alt={itemSelected.document.name}
                                      // src={itemSelected.document.mediaQualityURL}
                                      src={handleSetSrc(itemSelected.document)}
                                      className="responsive-img loading-middle-view"
                                    />
                                  )
                                )}
                                {itemSelected.document.type === "document" &&
                                  AUDIO_EXT.includes(
                                    fileextension(
                                      itemSelected.document.originalURL
                                    )
                                  ) && (
                                    <AudioView
                                      item={itemSelected.document}
                                      from={`middleView`}
                                      canCommentsAndVersions={true}
                                      timePickerEnabled={true}
                                      showCommentComponent={
                                        this.showCommentComponent
                                      }
                                    />
                                  )}
                                {itemSelected.document.type === "document" &&
                                !AUDIO_EXT.includes(
                                  fileextension(
                                    itemSelected.document.originalURL
                                  )
                                ) &&
                                fileextension(
                                  itemSelected.document.originalURL
                                ) !== "pdf" ? (
                                  <DocumentView
                                    item={itemSelected.document}
                                    from={`middleView`}
                                  />
                                ) : null
                                // (
                                //   fileextension(
                                //     itemSelected.document.originalURL
                                //   ) === 'pdf' ?
                                //     <VersionPdfViewContainer
                                //       // itemSelected={itemSelected}
                                //       from={`middleView3`}
                                //     />
                                //     : null)
                                }

                                {itemSelected.document.type === "video" && (
                                  <div
                                    style={{
                                      margin: "13px",
                                      marginBottom: "1%"
                                    }}
                                  >
                                    <VideoView
                                      url={
                                        itemSelected.document.mediaQualityURL
                                      }
                                      disableDefaultControls={false}
                                      autoPlay={false}
                                      muted={false}
                                      canCommentsAndVersions={true}
                                      updateRefValue2={this.updateRefValue}
                                      timePickerEnabled={true}
                                      showCommentComponent={
                                        this.showCommentComponent
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                            ) : (
                              <SkeletonTheme>
                                <p>
                                  <Skeleton height={400} />
                                </p>
                              </SkeletonTheme>
                            )}
                          </figure>
                        )}
                      </div>
                      <div
                        className="bb-archives-block__carrusel-actions"
                        style={{ visibility: "hidden" }}
                      >
                        <a href={hash}>
                          <svg
                            width={16}
                            height={2}
                            viewBox="0 0 16 2"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect width={16} height={2} fill="#1C9FDA" />
                          </svg>
                        </a>
                        <a href={hash}>
                          <svg
                            width={16}
                            height={16}
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              opacity="0.8"
                              d="M9.14048 6.90323H16V9.12903H9.14048V16H6.82622V9.12903H0V6.90323H6.82622V0H9.14048V6.90323Z"
                              fill="#20BCFF"
                            />
                          </svg>
                        </a>
                      </div>
                      <div className="bb-archives-block__carrusel-upload">
                        <div className="uploadVersionWrapper">
                          <span>
                            {" "}
                            <h1> 1 de 45</h1>{" "}
                          </span>
                          {canCreateVersionDart && (
                            <VersionAsset3
                              handleShowNewVersionAsset={() => {
                                this.props.handleShowNewVersionAsset({
                                  itemSelected: itemSelected,
                                  breadCrumbs: breadCrumbs
                                });
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    {/*.progress*/}
                    {/*.aproved*/}
                    {/*.feedback*/}
                    {/*.standby*/}
                    {/*.problem*/}
                    <div
                      className="bb-archives-block__switch"
                      onBlur={this.closeStatusAssetsList}
                    >
                      <div
                        className={
                          loadingStatusAsset
                            ? "content-switch loading"
                            : itemSelected.document &&
                              itemSelected.document.statusAsset
                            ? `content-switch bb-${itemSelected.document.statusAsset.type}`
                            : "content-switch question-none"
                        }
                        onClick={() =>
                          showStatusAssets
                            ? this.showOrHideStatusAssets(false)
                            : this.showOrHideStatusAssets(true)
                        }
                        style={
                          st && st.color && !loadingStatusAsset
                            ? {
                                border: `2px solid ${st.color}`,
                                color: st.color,
                                cursor: "pointer"
                              }
                            : { cursor: "pointer" }
                        }
                      >
                        {loadingStatusAsset
                          ? intl.formatMessage({ id: "loading" })
                          : st
                          ? st.title
                          : intl.formatMessage({ id: "for_assignment" })}
                      </div>
                      {showStatusAssets && (
                        <div
                          className="bb-archives-block__tags-old"
                          onMouseLeave={this.closeStatusAssetsList}
                          tabIndex="1"
                          ref="divshowstatus"
                        >
                          <ul>
                            {statusAsset.map((s, k) => (
                              <li
                                key={k}
                                onClick={() => this.setStatusAsset(s)}
                              >
                                <div style={s.color ? { color: s.color } : {}}>
                                  {s.title}
                                  <span>
                                    <img
                                      alt={s.type}
                                      src={`/images/img_v2/icon-btn-${s.type}.svg`}
                                    />
                                  </span>
                                </div>
                              </li>
                            ))}
                            <li>
                              <div
                                onClick={() =>
                                  this.showModalStatusAssetCreate(true)
                                }
                              >
                                Nuevo
                                <img
                                  alt="add"
                                  src={`/images/img_v2/icon-btn-add.png`}
                                />
                              </div>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                    <div className="bb-archives-block__tags">
                      <h3>
                        {dartCustomField ||
                          intl.formatMessage({ id: "available_means" })}
                      </h3>

                      <ul>
                        {media && mediaTags}

                        {canEditMediaDart && (
                          <li>
                            {" "}
                            <div
                              onClick={() => this.showModalMediaCreate(true)}
                            >
                              <img
                                style={{ marginRight: "10px" }}
                                width="17"
                                src={"/images/icon-plus.svg"}
                                alt="plus"
                              />
                              {intl.formatMessage({
                                id: "add"
                              })}
                            </div>
                          </li>
                        )}
                      </ul>

                      {!itemSelectedFetching &&
                        itemSelected.document &&
                        itemSelected.document.metadata.descriptiveTags.length >
                          0 && (
                          <div>
                            <div className="bb-archives-block__tags-add">
                              <h3>Agregar tag</h3>
                            </div>
                            <div className="bb-archives-block__tags-input">
                              <div className="bb-archives-block__tags-content">
                                <div className="bb-archives-block__tags-items">
                                  {!itemSelectedFetching &&
                                    itemSelected.document &&
                                    itemSelected.document.metadata.descriptiveTags.map(
                                      (r, k) => (
                                        <TagDart
                                          tagInfo={r}
                                          key={k}
                                          handleTagSearch={this.handleTagSearch}
                                        />
                                      )
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="bb-archives-block__profile">
                      <div className="bb-archives-block__profile-top">
                        <div className="box1">
                          <h4>{intl.formatMessage({ id: "uploaded_by" })} </h4>
                        </div>
                        <div className="box2">
                          <h4>{intl.formatMessage({ id: "upload_date" })}</h4>
                        </div>
                      </div>
                      <div className="bb-archives-block__profile-users">
                        <div className="bb-archives-block__user">
                          <div>
                            <figure>
                              <img alt="user-profile" src={defaultAvatar} />
                            </figure>
                            <p>
                              {!itemSelectedFetching &&
                              itemSelected.document &&
                              itemSelected.userCreator
                                ? itemSelected.userCreator.name
                                : intl.formatMessage({ id: "user_not_found" })}
                            </p>
                          </div>
                        </div>
                        <div className="bb-archives-block__date">
                          {!itemSelectedFetching && itemSelected.document && (
                            <p>
                              {moment(itemSelected.document.createdAt)
                                .locale("es")
                                .format("dddd LL")}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  !isShowComments
                    ? "bb-comments-block"
                    : "bb-comments-block enabled"
                }
              >
                <RightButtonsV2
                  itemSelected={itemSelected}
                  isShowComments={isShowComments}
                  isShowCompareVersion={isShowCompareVersion}
                  isShowVersions={isShowVersions}
                  showOrHideViews={this.showOrHideViews}
                  shouldShowVersionsButton={canViewVersionsDart}
                  info={
                    itemSelected.document.type === "video"
                      ? "Botones de control para opciones de video"
                      : itemSelected.document.type === "audio"
                      ? "Botones de control para opciones de audio"
                      : null
                  }
                />
                <MainCommentsTopv2
                  canCreateCommentDart={canCreateCommentDart}
                  searchComments={searchComments}
                  saveRecommendedText={saveRecommendedText}
                  comment={comment}
                  recommendedText={recommendedText}
                  itemsComments={itemsComments}
                  //Funciones
                  searchCommentsFilters={this.searchCommentsFilters}
                  handleKeyDown={this.handleKeyDown}
                  handleCommentTextChange={this.handleCommentTextChange}
                  onAddMention={this.onAddMention}
                  deleteRecommendedText={this.deleteRecommendedText}
                  selectRecommendedText={this.selectRecommendedText}
                  showSaveRecommendedText={this.showSaveRecommendedText}
                  showRecommendedText={this.showRecommendedText}
                  handleSaveRecommendedText={this.handleSaveRecommendedText}
                  handleSubmit={this.handleSubmit}
                  addEmojiToComment={this.addEmojiToComment}
                  focusInCurrentTarget={this.focusInCurrentTarget}
                  closeRecommendedText={this.closeRecommendedText}
                />
                <MainCommentsListv2
                  canCreateCommentDart={canCreateCommentDart}
                  handleShowModalDeleteComment={
                    this.handleShowModalDeleteComment
                  }
                  searchComments={searchComments}
                  updateComment={this.props.updateComment}
                />
              </div>

              <div
                className={
                  !isShowFiles
                    ? "bb-comments-block"
                    : "bb-comments-block enabled"
                }
              >
                <RightButtonsV2
                  itemSelected={itemSelected}
                  isShowComments={isShowComments}
                  isShowCompareVersion={isShowCompareVersion}
                  isShowVersions={isShowVersions}
                  showOrHideViews={this.showOrHideViews}
                  shouldShowVersionsButton={canViewVersionsDart}
                  info={
                    itemSelected.document.type === "video"
                      ? "Botones de control para opciones de video"
                      : itemSelected.document.type === "audio"
                      ? "Botones de control para opciones de audio"
                      : null
                  }
                />
                <MainFilesList />
              </div>

              {canViewVersionsDart && (
                <div
                  className={
                    isShowVersions || isShowCompareVersion
                      ? "bb-history enabled"
                      : "bb-history"
                  }
                >
                  <RightButtonsV2
                    itemSelected={itemSelected}
                    isShowComments={isShowComments}
                    isShowCompareVersion={isShowCompareVersion}
                    isShowVersions={isShowVersions}
                    isShowFiles={isShowFiles}
                    showOrHideViews={this.showOrHideViews}
                    shouldShowVersionsButton={canViewVersionsDart}
                  />

                  <MainVersionsTop
                    //Variables
                    isShowCompareVersion={isShowCompareVersion}
                    opviews={opviews}
                    //Funciones
                    showOrHideViews={this.showOrHideViews}
                    showModalCompareVersion={this.showModalCompareVersion}
                  />
                  <MainVersionsList
                    //Variables
                    showModalDeleteVersion={showModalDeleteVersion}
                    showModalSelectVersion={showModalSelectVersion}
                    showModalDeleteMedia={showModalDeleteMedia}
                    showModalDeleteStatus={showModalDeleteStatus}
                    showModalDeleteComment={showModalDeleteComment}
                    commentDelete={commentDelete}
                    itemsVersionsForCompare={itemsVersionsForCompare}
                    isShowCompareVersion={isShowCompareVersion}
                    //Funciones
                    deleteVersion={this.deleteVersion}
                    hideDeleteVersion={this.hideDeleteVersion}
                    setSelectVersion={this.setSelectVersion}
                    hideSelectVersion={this.hideSelectVersion}
                    deleteMedia={this.deleteMedia}
                    deleteStatus={this.deleteStatus}
                    handleDeleteComment={this.handleDeleteComment}
                    addItemsForCompare={this.addItemsForCompare}
                    showDeleteVersion={this.showDeleteVersion}
                    showSelectVersion={this.showSelectVersion}
                    closeModalDeleteMedia={this.closeModalDeleteMedia}
                    closeModalDeleteStatus={this.closeModalDeleteStatus}
                    closeModalDeleteComment={this.closeModalDeleteComment}
                  />
                </div>
              )}

              <div
                className="bb-archives-block enabled"
                ref={this.archiveBlockRef}
              >
                <div className="block-scroll">
                  <div className="bb-archives-block__top">
                    <div className="bb-archives-block__brand">
                      <img
                        alt=""
                        src="/images/img_v2/upload-head-logo.svg"
                        style={{ marginRight: "20px" }}
                      />{" "}
                      <svg
                        width="33"
                        height="32"
                        viewBox="0 0 33 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.79852 23.2894L4.0516 23.6879L3.84369 24.1118L1.41027 29.0722L8.07017 28.5157L8.37725 28.4901L8.62837 28.6687C11.0856 30.4164 13.5464 31.1579 16.842 31.1579C25.2135 31.1579 31.9999 24.3715 31.9999 16C31.9999 7.62853 25.2135 0.842105 16.842 0.842105C8.47057 0.842105 1.68415 7.62853 1.68415 16C1.68415 18.9853 2.30826 20.9428 3.79852 23.2894Z"
                          fill="#0E2A45"
                          stroke="#0096D6"
                          strokeWidth="1.68421"
                        />
                        <circle
                          cx="9.61403"
                          cy="15.6138"
                          r="1.61378"
                          fill="#0096D6"
                        />
                        <circle
                          cx="16.7839"
                          cy="15.6138"
                          r="1.61378"
                          fill="#0096D6"
                        />
                        <circle
                          cx="23.9539"
                          cy="15.6138"
                          r="1.61378"
                          fill="#0096D6"
                        />
                      </svg>
                    </div>
                    <div className="bb-archives-block__pagination">
                      <div
                        className="bb-archives-block__arrows"
                        style={{ display: fromKeyCollection ? "" : "none" }}
                      >
                        {/* <input
                          type="text"
                          placeholder="Buscar archivo"
                          style={{
                            background: "transparent",
                            marginRight: 5,
                            border: "1px solid #0096d6",
                            borderRadius: 8,
                            padding: 10
                          }}
                        /> */}
                        <Tooltip placement="top" title="Anterior">
                          <div
                            className="arrow-prev"
                            onClick={() => this.moveAssetExplorer("prev")}
                            style={{ marginRight: 5 }}
                          >
                            <svg
                              width={8}
                              height={13}
                              viewBox="0 0 8 13"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7 1L1.27083 6.5L7 12"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        </Tooltip>
                        <Tooltip placement="top" title="Siguiente">
                          <div
                            className="arrow-next"
                            onClick={() => this.moveAssetExplorer("next")}
                          >
                            <svg
                              width={8}
                              height={13}
                              viewBox="0 0 8 13"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1 1L6.72917 6.5L1 12"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                  <div className="bb-archives-block__actions">
                    <div className="bb-archives-block__bradcrumb">
                      <ul>
                        <li>
                          <a href={hash}>Bunkey</a>
                        </li>
                        {breadCrumbs.map((r, k) => (
                          <div key={k}>
                            <span>/ </span>
                            <Link
                              to={`/home/explore/${r.id}`}
                              onClick={() => this.props.hideComment(intl)}
                              key={k}
                            >
                              {r.name}
                            </Link>
                          </div>
                        ))}
                      </ul>
                    </div>
                    <h2 style={{ fontSize: 40, fontWeight: 300 }}>
                      {!itemSelectedFetching && itemSelected.document ? (
                        itemSelected.document.name
                      ) : (
                        <SkeletonTheme>
                          <p>
                            <Skeleton height={32} />
                          </p>
                        </SkeletonTheme>
                      )}
                    </h2>
                    <div className="bb-archives-block__carrusel video">
                      <div className="bb-archives-block__carrusel-big">
                        <figure>
                          {!itemSelectedFetching && itemSelected.document ? (
                            <div>
                              {itemSelected.document.type === "image" &&
                              fileextension(
                                itemSelected.document.originalURL
                              ) === "svg" ? (
                                <SVGView
                                  comFromMiddleView={true}
                                  src={itemSelected.document.originalURL}
                                  assetId={itemSelected.document._id}
                                />
                              ) : itemSelected.document.type === "image" &&
                                fileextension(
                                  itemSelected.document.originalURL
                                ) !== "png" ? (
                                  <div>
                                    <Magnifier
                                      mgShowOverflow={false}
                                      alt={itemSelected.document.name}
                                      src={handleSetSrc(itemSelected.document)}
                                      className="responsive-img raw_asset_formats"
                                      width={
                                        isDefaultAssetPath(
                                          handleSetSrc(itemSelected.document)
                                        )
                                          ? "50%"
                                          : "100%"
                                      }
                                      onClick={this.handleImageClick}
                                      />
                                      {isImageTagActive && <PointIndicator
                                        pointX = {imageTagXPer * imageTagWidth / 100.0}
                                        pointY = {imageTagYPer * imageTagHeight / 100.0}
                                        imagePoint = {nextIndexPointImage}
                                      />}
                                      {showPointsImages && pointsCommentsImages.map((pComent) => {
                                        return (
                                          <PointIndicator
                                            pointX = {pComent.fileTag.imagePoint.pointX}
                                            pointY = {pComent.fileTag.imagePoint.pointY}
                                            imagePoint = {pComent.fileTag.imagePoint.index}
                                          />
                                        )
                                        })
                                      }
                                  </div>
                              ) : (
                                itemSelected.document.type === "image" && (
                                  <div
                                    style={{
                                      position: "relative"
                                    }}
                                  >
                                    <Magnifier
                                      mgShowOverflow={false}
                                      alt={itemSelected.document.name}
                                      src={handleSetSrc(itemSelected.document)}
                                      className="responsive-img loading-middle-view"
                                      onClick={this.handleImageClick}
                                    />
                                    {isImageTagActive && <PointIndicator
                                      pointX = {imageTagXPer * imageTagWidth / 100.0}
                                      pointY = {imageTagYPer * imageTagHeight / 100.0}
                                      imagePoint = {nextIndexPointImage}
                                    />}
                                    {showPointsImages && pointsCommentsImages.map((pComent) => {
                                      return (
                                        <PointIndicator
                                          pointX = {pComent.fileTag.imagePoint.pointX}
                                          pointY = {pComent.fileTag.imagePoint.pointY}
                                          imagePoint = {pComent.fileTag.imagePoint.index}
                                        />
                                      )
                                      })
                                    }
                                  </div>
                                )
                              )}
                              {itemSelected.document.type === "document" &&
                                AUDIO_EXT.includes(
                                  fileextension(
                                    itemSelected.document.originalURL
                                  )
                                ) && (
                                  <AudioView
                                    item={itemSelected.document}
                                    from={`middleView`}
                                    autoPlay={true}
                                    canCommentsAndVersions={true}
                                    timePickerEnabled={true}
                                    showCommentComponent={
                                      this.showCommentComponent
                                    }
                                  />
                                )}
                              {itemSelected.document.type === "audio" &&
                                AUDIO_EXT.includes(
                                  fileextension(
                                    itemSelected.document.originalURL
                                  )
                                ) && (
                                  <AudioView
                                    item={itemSelected.document}
                                    from={`middleView`}
                                    autoPlay={true}
                                    canCommentsAndVersions={true}
                                    timePickerEnabled={true}
                                    showCommentComponent={
                                      this.showCommentComponent
                                    }
                                  />
                                )}
                              {itemSelected.document.type === "document" &&
                              !AUDIO_EXT.includes(
                                fileextension(itemSelected.document.originalURL)
                              ) &&
                              fileextension(
                                itemSelected.document.originalURL
                              ) !== "pdf" ? (
                                <DocumentView
                                  item={itemSelected.document}
                                  from={`middleView`}
                                />
                              ) : fileextension(
                                  itemSelected.document.originalURL
                                ) === "pdf" &&
                                itemSelected.document.documentPages &&
                                itemSelected.document.convertionStatus ===
                                  SUCCESS_STATUS &&
                                itemSelected.document.documentPages.length >
                                  0 ? (
                                <React.Fragment>
                                  <PDFViewContainer
                                    itemSelected={itemSelected}
                                    from={`middleView4`}
                                    showCommentComponent={
                                      this.showCommentComponent
                                    }
                                    isShowComments={isShowComments}
                                  />
                                </React.Fragment>
                              ) : (
                                fileextension(
                                  itemSelected.document.originalURL
                                ) === "pdf" && (
                                  <AssetConvertinatorStatusView
                                    document={itemSelected.document}
                                  />
                                )
                              )}
                              {itemSelected.document.type === "video" && (
                                <div
                                  style={{ margin: "13px", marginBottom: "1%" }}
                                >
                                  <VideoView
                                    url={itemSelected.document.mediaQualityURL}
                                    disableDefaultControls={false}
                                    autoPlay={true}
                                    muted={false}
                                    canCommentsAndVersions={true}
                                    updateRefValue2={this.updateRefValue}
                                    timePickerEnabled={true}
                                    showCommentComponent={
                                      this.showCommentComponent
                                    }
                                  />
                                </div>
                              )}
                              {itemSelected.document.type === "font" && (
                                <div>
                                  <DocumentView
                                    item={itemSelected.document}
                                    from={`middleView`}
                                  />
                                </div>
                              )}
                              {itemSelected.document.type === "other" && (
                                <div>
                                  <DocumentView
                                    item={itemSelected.document}
                                    from={`middleView`}
                                  />
                                </div>
                              )}
                            </div>
                          ) : (
                            <SkeletonTheme>
                              <p>
                                <Skeleton height={400} />
                              </p>
                            </SkeletonTheme>
                          )}
                        </figure>
                      </div>
                      <div
                        className="bb-archives-block__carrusel-actions"
                        style={{ visibility: "hidden" }}
                      >
                        <a href={hash}>
                          <svg
                            width={16}
                            height={2}
                            viewBox="0 0 16 2"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect width={16} height={2} fill="#1C9FDA" />
                          </svg>
                        </a>
                        <a href={hash}>
                          <svg
                            width={16}
                            height={16}
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              opacity="0.8"
                              d="M9.14048 6.90323H16V9.12903H9.14048V16H6.82622V9.12903H0V6.90323H6.82622V0H9.14048V6.90323Z"
                              fill="#20BCFF"
                            />
                          </svg>
                        </a>
                      </div>
                      <div className="bb-archives-block__carrusel-upload">
                        <div className="uploadVersionWrapper">
                          {canCreateVersionDart && (
                            <VersionAsset3
                              handleShowNewVersionAsset={() => {
                                this.props.handleShowNewVersionAsset({
                                  itemSelected: itemSelected,
                                  breadCrumbs: breadCrumbs
                                });
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      className="bb-archives-block__comments"
                      ref={this.descriptionRef}
                      style={{ marginBottom: 38 }}
                    >
                      <TextEditorDart
                        editAsset={this.editDescriptionAsset}
                        contentState={desp}
                        isUpdating={loadingDescription}
                        changeFocusDescription={this.changeFocusDescription}
                        intl={this.props.intl}
                      />
                    </div>
                    <div
                      className="bb-archives-block__switch"
                      onBlur={this.closeStatusAssetsList}
                    >
                      <div
                        data-img={itemSelected.document && itemSelected.document.statusAsset ? itemSelected.document.statusAsset.type : null}
                        data-color={st && st.color ? st && st.color : null}
                        className={
                          loadingStatusAsset
                            ? "content-switch bb-loading"
                            : itemSelected.document &&
                              itemSelected.document.statusAsset
                            ? `content-switch bb-${itemSelected.document.statusAsset.type}`
                            : "content-switch bb-question-none"
                        }
                        onClick={() => {
                          if (canEditStatesDart)
                            showStatusAssets
                              ? this.showOrHideStatusAssets(false)
                              : this.showOrHideStatusAssets(true);
                        }}
                        style={
                          st && st.color && !loadingStatusAsset
                            ? {
                                border: `2px solid ${st.color}`,
                                color: st.color,
                                cursor: "pointer",
                                "--my-color-var": st.color,
                                "--my-img-var": itemSelected.document && itemSelected.document.statusAsset ? `url(/images/img_v2/icon-btn-${itemSelected.document.statusAsset.type}.${itemSelected.document.statusAsset.type === 'warning'? 'png' : 'svg'})` : null,
                              }
                            : { cursor: "pointer" }
                        }
                      >
                        {loadingStatusAsset
                          ? intl.formatMessage({
                              id: "loading"
                            })
                          : st
                          ? st.title
                          : intl.formatMessage({
                              id: "for_assignment"
                            })}
                      </div>
                      {showStatusAssets && (
                        <div
                          className="bb-archives-block__tags-old"
                          onMouseLeave={this.closeStatusAssetsList}
                          tabIndex="1"
                          ref="divshowstatus"
                        >
                          <ul>
                            {statusAsset.map((s, k) => (
                              <li key={k}>
                                <div style={{ float: "left" }}>
                                  <span
                                    onClick={() => this.showDeleteStatus(s._id)}
                                  >
                                    &times;
                                  </span>
                                </div>
                                <div
                                  className="media-title"
                                  style={s.color ? { color: s.color } : {}}
                                  onClick={() => this.setStatusAsset(s)}
                                >
                                  {s.title}
                                  <span>
                                    <img
                                      alt={s.type}
                                      src={s.type === 'warning' ? `/images/img_v2/icon-btn-${s.type}.png` : `/images/img_v2/icon-btn-${s.type}.svg`}
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                      }}
                                    />
                                  </span>
                                </div>
                              </li>
                            ))}
                            <li>
                              <div
                                onClick={() =>
                                  this.showModalStatusAssetCreate(true)
                                }
                              >
                                {intl.formatMessage({ id: "new" })}
                                <img
                                  alt="add"
                                  src={`/images/img_v2/icon-btn-add.png`}
                                />
                              </div>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                    <div className="bb-archives-block__tags">
                      <h3>
                        {dartCustomField ||
                          intl.formatMessage({ id: "stamps_title" })}
                      </h3>
                      {mediaTags.length === 0 && (
                        <div className="center-div">
                          <h3>
                            {intl.formatMessage({ id: "stamps_empty_title" })}
                          </h3>
                        </div>
                      )}
                      <ul>
                        {media && mediaTags}
                        {canEditMediaDart && (
                          <li>
                            {" "}
                            <div
                              onClick={() => this.showModalMediaCreate(true)}
                            >
                              <img
                                style={{ margin: "0 10px 0 0" }}
                                width="17"
                                src={"/images/icon-plus.svg"}
                                alt="plus"
                              />
                              {intl.formatMessage({ id: "add" })}
                            </div>
                          </li>
                        )}
                      </ul>
                      {!itemSelectedFetching &&
                        itemSelected.document &&
                        itemSelected.document.metadata.descriptiveTags.length >
                          0 && (
                          <div>
                            <div className="bb-archives-block__tags-add">
                              <h3>Agregar tag</h3>
                              {/* <div>
                                Mostrar tags antiguos &nbsp;
                                <svg
                                  width="22"
                                  height="26"
                                  viewBox="0 0 22 23"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M1 22.7861C0.999923 22.8923 1.02707 22.9968 1.07885 23.0895C1.13064 23.1822 1.20533 23.2601 1.29579 23.3157C1.38625 23.3714 1.48946 23.4029 1.59557 23.4073C1.70168 23.4117 1.80714 23.3888 1.90189 23.3408C2.77626 22.9114 3.75378 22.7365 4.7228 22.8361C5.69182 22.9358 6.61329 23.3059 7.38197 23.9043C8.2943 24.6144 9.4174 25 10.5735 25C11.7296 25 12.8527 24.6144 13.7651 23.9043C14.5337 23.3059 15.4552 22.9358 16.4242 22.8361C17.3933 22.7365 18.3708 22.9114 19.2451 23.3408C19.3399 23.3888 19.4453 23.4117 19.5515 23.4073C19.6576 23.4029 19.7608 23.3714 19.8512 23.3157C19.9417 23.2601 20.0164 23.1822 20.0682 23.0895C20.12 22.9968 20.1471 22.8923 20.147 22.7861V10.5724C20.147 9.31525 19.8994 8.0704 19.4183 6.90895C18.9371 5.7475 18.2319 4.69219 17.3429 3.8033C16.4539 2.91441 15.3986 2.20933 14.2371 1.72834C13.0755 1.24734 11.8307 0.999854 10.5735 1C9.31636 0.999854 8.07148 1.24734 6.90997 1.72834C5.74847 2.20933 4.69308 2.91441 3.80409 3.8033C2.91509 4.69219 2.20989 5.7475 1.72876 6.90895C1.24764 8.0704 1 9.31525 1 10.5724V22.7861Z"
                                    stroke="white"
                                  />
                                  <path
                                    d="M6.45789 12.2683C7.66055 12.2683 8.6355 11.2934 8.6355 10.0907C8.6355 8.88804 7.66055 7.91309 6.45789 7.91309C5.25522 7.91309 4.28027 8.88804 4.28027 10.0907C4.28027 11.2934 5.25522 12.2683 6.45789 12.2683Z"
                                    fill="white"
                                  />
                                  <path
                                    d="M14.6888 12.2683C15.8915 12.2683 16.8665 11.2934 16.8665 10.0907C16.8665 8.88804 15.8915 7.91309 14.6888 7.91309C13.4862 7.91309 12.5112 8.88804 12.5112 10.0907C12.5112 11.2934 13.4862 12.2683 14.6888 12.2683Z"
                                    fill="white"
                                  />
                                </svg>
                              </div> */}
                            </div>
                            <div className="bb-archives-block__tags-input">
                              <div className="bb-archives-block__tags-content">
                                <div className="bb-archives-block__tags-items">
                                  {!itemSelectedFetching &&
                                    itemSelected.document &&
                                    itemSelected.document.metadata.descriptiveTags.map(
                                      (r, k) => (
                                        <TagDart
                                          tagInfo={r}
                                          key={k}
                                          handleTagSearch={this.handleTagSearch}
                                        />
                                      )
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="bb-archives-block__profile">
                      <div className="bb-archives-block__profile-top">
                        <div className="box1">
                          <h4>{intl.formatMessage({ id: "uploaded_by" })} </h4>
                        </div>
                        <div className="box2">
                          <h4>{intl.formatMessage({ id: "upload_date" })}</h4>
                        </div>
                      </div>
                      <div className="bb-archives-block__profile-users">
                        <div className="bb-archives-block__user">
                          <div>
                            <figure>
                              <img alt="user-profile" src={defaultAvatar} />
                            </figure>
                            <p>
                              {!itemSelectedFetching &&
                              itemSelected.document &&
                              itemSelected.userCreator
                                ? itemSelected.userCreator.name
                                : intl.formatMessage({ id: "user_not_found" })}
                            </p>
                          </div>
                        </div>

                        <div className="bb-archives-block__date">
                          {!itemSelectedFetching && itemSelected.document && (
                            <p>
                              {moment(itemSelected.document.createdAt)
                                .locale("es")
                                .format("dddd LL")}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                modalCreateMedia
                  ? "bb-modal newmedio"
                  : modalCompareVersion
                  ? "bb-modal archive-grid"
                  : statusAssetCreate
                  ? "bb-modal newstatus"
                  : "bb-modal"
              }
            >
              <div
                className="bb-modal__newmedio"
                onBlur={this.closeAll}
                tabIndex="1"
                ref="divnewmedio"
              >
                <h2>{intl.formatMessage({ id: "add_new_stamp" })}</h2>
                <a
                  className="close-newmedio"
                  href={hash}
                  onClick={() => this.showModalMediaCreate(false)}
                >
                  <svg
                    width={21}
                    height={22}
                    viewBox="0 0 21 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.75942 7.89313C6.91611 8.05062 7.12206 8.12896 7.32801 8.12896C7.53396 8.12896 7.73991 8.05062 7.8966 7.89313C8.21078 7.57895 8.21078 7.06932 7.8966 6.75514L1.46363 0.315711C1.14945 0.00153374 0.640631 0.00153374 0.326454 0.315711C0.0122759 0.629889 0.0122759 1.13952 0.326454 1.4537L6.75942 7.89313Z"
                      fill="white"
                    />
                    <path
                      d="M11.6823 10.5442L20.7644 1.45406C21.0785 1.13989 21.0785 0.630257 20.7644 0.316079C20.4502 0.00190138 19.9414 -0.137015 19.6272 0.17797L9.97733 9.69779H9.73827V9.97643L0.207944 19.6344C-0.106233 19.9485 -0.046467 20.4582 0.266903 20.7724C0.423588 20.9298 0.659423 21.0082 0.865375 21.0082C1.07133 21.0082 1.29182 20.9298 1.4485 20.7724L10.5378 11.683L19.6231 20.7732C19.7798 20.9307 19.9882 21.009 20.1934 21.009C20.3985 21.009 20.6061 20.9307 20.7628 20.7732C21.0769 20.459 21.0777 19.9494 20.7636 19.6352L11.6823 10.5442Z"
                      fill="white"
                    />
                  </svg>
                </a>
                <div className="bb-modal__medio-name">
                  <input
                    type="text"
                    maxLength="22"
                    name="mediaName"
                    value={mediaName}
                    placeholder={intl.formatMessage({
                      id: "add_new_stamp_name"
                    })}
                    onChange={this.handleInputOnChange}
                    ref={ip => (this.newmedio = ip)}
                  />

                  <div className="medio-colors">
                    <span
                      style={{
                        background: mediaColorState,
                        border: "2px solid white"
                      }}
                      onClick={() =>
                        this.setState({ showColorPicker: !showColorPicker })
                      }
                    ></span>
                    {showColorPicker ? (
                      <CirclePicker
                        width="150px"
                        className="color-picker"
                        onChangeComplete={this.handleChangeMediaColor}
                      />
                    ) : (
                      mediaColorState
                    )}
                  </div>
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <span>{mediaName.length}/88</span>
                </div>
                <div className="bb-modal__medio-icon">
                  <p>{intl.formatMessage({ id: "add_new_stamp_pick_icon" })}</p>
                  {mediaList.map((m, k) => {
                    return (
                      <div
                        key={k}
                        style={{
                          width: "70px",
                          background: "none",
                          display: "inline-block",
                          border:
                            selectedMediaIcon === m
                              ? "1px solid #0096d6"
                              : "none"
                        }}
                      >
                        <Icon
                          type={m}
                          style={{
                            fontSize: "20px",
                            width: "70px",
                            marginTop: "7px",
                            marginBottom: "7px",
                            cursor: "pointer",
                            color: "#FFFFFF"
                          }}
                          onClick={() =>
                            this.setState({ selectedMediaIcon: m })
                          }
                        ></Icon>
                      </div>
                    );
                  })}
                </div>
                <button
                  className="send-newmedio"
                  onClick={this.hanleCreateNewMedia}
                >
                  {intl.formatMessage({ id: "save_title" })}
                </button>
              </div>
              <div
                className="bb-modal__newstatus"
                onBlur={this.closeAll}
                tabIndex="1"
                ref="divnewstatus"
              >
                <h2>{intl.formatMessage({ id: "new_status" })}</h2>
                <a
                  className="close-newstatus"
                  href={hash}
                  onClick={() => this.showModalStatusAssetCreate(false)}
                >
                  <svg
                    width={21}
                    height={22}
                    viewBox="0 0 21 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.75942 7.89313C6.91611 8.05062 7.12206 8.12896 7.32801 8.12896C7.53396 8.12896 7.73991 8.05062 7.8966 7.89313C8.21078 7.57895 8.21078 7.06932 7.8966 6.75514L1.46363 0.315711C1.14945 0.00153374 0.640631 0.00153374 0.326454 0.315711C0.0122759 0.629889 0.0122759 1.13952 0.326454 1.4537L6.75942 7.89313Z"
                      fill="white"
                    />
                    <path
                      d="M11.6823 10.5442L20.7644 1.45406C21.0785 1.13989 21.0785 0.630257 20.7644 0.316079C20.4502 0.00190138 19.9414 -0.137015 19.6272 0.17797L9.97733 9.69779H9.73827V9.97643L0.207944 19.6344C-0.106233 19.9485 -0.046467 20.4582 0.266903 20.7724C0.423588 20.9298 0.659423 21.0082 0.865375 21.0082C1.07133 21.0082 1.29182 20.9298 1.4485 20.7724L10.5378 11.683L19.6231 20.7732C19.7798 20.9307 19.9882 21.009 20.1934 21.009C20.3985 21.009 20.6061 20.9307 20.7628 20.7732C21.0769 20.459 21.0777 19.9494 20.7636 19.6352L11.6823 10.5442Z"
                      fill="white"
                    />
                  </svg>
                </a>
                <div className="bb-modal__status-name">
                  <input
                    type="text"
                    name="statusName"
                    value={statusName}
                    maxLength="11"
                    placeholder={intl.formatMessage({
                      id: "name"
                    })}
                    onChange={this.handleInputOnChange}
                    ref={ip => (this.newstatus = ip)}
                  />
                  <div className="status-colors">
                    <span
                      style={{
                        background: statusColorState,
                        border: "2px solid white"
                      }}
                      onClick={() =>
                        this.setState({ showColorPicker: !showColorPicker })
                      }
                    ></span>
                    {showColorPicker ? (
                      <CirclePicker
                        width="150px"
                        className="color-picker"
                        onChangeComplete={this.handleChangeStatusColor}
                      />
                    ) : (
                      statusColorState
                    )}
                  </div>
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <span>{statusName.length}/11</span>
                </div>
                <div className="bb-modal__status-icon">
                  <p>
                    {" "}
                    {intl.formatMessage({
                      id: "add_new_stamp_pick_icon"
                    })}{" "}
                  </p>
                  {statusList.map((m, k) => {
                    return (
                      <div
                        key={k}
                        style={{
                          width: "70px",
                          background: "none",
                          display: "inline-block",
                          border:
                            selectedStatusIcon === m
                              ? "1px solid #0096d6"
                              : "none",
                          textAlign: "center"
                        }}
                      >
                        <img
                          alt={m}
                          src={`/images/img_v2/icon-btn-${m}.svg`}
                          style={{
                            width: "22px",
                            height: "22px",
                            marginTop: "6px",
                            marginBottom: "6px",
                            cursor: "pointer"
                          }}
                          onClick={() =>
                            this.setState({ selectedStatusIcon: m })
                          }
                        />
                      </div>
                    );
                  })}
                </div>
                <a
                  href={hash}
                  className="send-newstatus"
                  onClick={this.handleCreateStatus}
                >
                  {intl.formatMessage({ id: "save_title" })}
                </a>
              </div>
              <div
                className="bb-modal__lightbox"
                onBlur={this.closeAll}
                tabIndex="1"
              >
                <a className="close-lightbox" href={hash}>
                  <svg
                    width={21}
                    height={22}
                    viewBox="0 0 21 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.75942 7.89313C6.91611 8.05062 7.12206 8.12896 7.32801 8.12896C7.53396 8.12896 7.73991 8.05062 7.8966 7.89313C8.21078 7.57895 8.21078 7.06932 7.8966 6.75514L1.46363 0.315711C1.14945 0.00153374 0.640631 0.00153374 0.326454 0.315711C0.0122759 0.629889 0.0122759 1.13952 0.326454 1.4537L6.75942 7.89313Z"
                      fill="white"
                    />
                    <path
                      d="M11.6823 10.5442L20.7644 1.45406C21.0785 1.13989 21.0785 0.630257 20.7644 0.316079C20.4502 0.00190138 19.9414 -0.137015 19.6272 0.17797L9.97733 9.69779H9.73827V9.97643L0.207944 19.6344C-0.106233 19.9485 -0.046467 20.4582 0.266903 20.7724C0.423588 20.9298 0.659423 21.0082 0.865375 21.0082C1.07133 21.0082 1.29182 20.9298 1.4485 20.7724L10.5378 11.683L19.6231 20.7732C19.7798 20.9307 19.9882 21.009 20.1934 21.009C20.3985 21.009 20.6061 20.9307 20.7628 20.7732C21.0769 20.459 21.0777 19.9494 20.7636 19.6352L11.6823 10.5442Z"
                      fill="white"
                    />
                  </svg>
                </a>
                <div className="bb-modal__lightbox-items">
                  <a className="bb-modal__lightbox-item select" href={hash}>
                    <img alt="" src="/images/img_v2/carrusel-thumb01.png" />
                  </a>
                  <a className="bb-modal__lightbox-item" href={hash}>
                    <img alt="" src="/images/img_v2/carrusel-thumb01.png" />
                  </a>
                  <a className="bb-modal__lightbox-item" href={hash}>
                    <img alt="" src="/images/img_v2/carrusel-thumb01.png" />
                  </a>
                  <a className="bb-modal__lightbox-item" href={hash}>
                    <img alt="" src="/images/img_v2/carrusel-thumb01.png" />
                  </a>
                </div>
                <div className="bb-modal__lightbox-item-xl">
                  <img alt="" src="/images/img_v2/carrusel-xl-thumb01.png" />
                </div>
              </div>
              <div
                className="bb-modal__archive"
                onBlur={this.closeAll}
                tabIndex="1"
              >
                <div className="bb-modal__archive-top">
                  <p>Nombre del archivo</p>
                  <a className="close-lightbox" href={hash}>
                    <svg
                      width={21}
                      height={22}
                      viewBox="0 0 21 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.75942 7.89313C6.91611 8.05062 7.12206 8.12896 7.32801 8.12896C7.53396 8.12896 7.73991 8.05062 7.8966 7.89313C8.21078 7.57895 8.21078 7.06932 7.8966 6.75514L1.46363 0.315711C1.14945 0.00153374 0.640631 0.00153374 0.326454 0.315711C0.0122759 0.629889 0.0122759 1.13952 0.326454 1.4537L6.75942 7.89313Z"
                        fill="white"
                      />
                      <path
                        d="M11.6823 10.5442L20.7644 1.45406C21.0785 1.13989 21.0785 0.630257 20.7644 0.316079C20.4502 0.00190138 19.9414 -0.137015 19.6272 0.17797L9.97733 9.69779H9.73827V9.97643L0.207944 19.6344C-0.106233 19.9485 -0.046467 20.4582 0.266903 20.7724C0.423588 20.9298 0.659423 21.0082 0.865375 21.0082C1.07133 21.0082 1.29182 20.9298 1.4485 20.7724L10.5378 11.683L19.6231 20.7732C19.7798 20.9307 19.9882 21.009 20.1934 21.009C20.3985 21.009 20.6061 20.9307 20.7628 20.7732C21.0769 20.459 21.0777 19.9494 20.7636 19.6352L11.6823 10.5442Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </div>
                <div className="bb-modal__archive-image">
                  <img alt="" src="/images/img_v2/carrusel-thumb-archive.png" />
                </div>
              </div>
              <div
                className="bb-modal__archive-grid"
                tabIndex="1"
                ref="divarchivegrid"
              >
                <div className="bb-modal__archive-grid-top">
                  <p style={{ visibility: "hidden" }}>Nombre del archivo</p>
                  <span
                    className="close-lightbox"
                    onClick={() => this.showModalCompareVersion(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <svg
                      width={21}
                      height={22}
                      viewBox="0 0 21 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.75942 7.89313C6.91611 8.05062 7.12206 8.12896 7.32801 8.12896C7.53396 8.12896 7.73991 8.05062 7.8966 7.89313C8.21078 7.57895 8.21078 7.06932 7.8966 6.75514L1.46363 0.315711C1.14945 0.00153374 0.640631 0.00153374 0.326454 0.315711C0.0122759 0.629889 0.0122759 1.13952 0.326454 1.4537L6.75942 7.89313Z"
                        fill="white"
                      />
                      <path
                        d="M11.6823 10.5442L20.7644 1.45406C21.0785 1.13989 21.0785 0.630257 20.7644 0.316079C20.4502 0.00190138 19.9414 -0.137015 19.6272 0.17797L9.97733 9.69779H9.73827V9.97643L0.207944 19.6344C-0.106233 19.9485 -0.046467 20.4582 0.266903 20.7724C0.423588 20.9298 0.659423 21.0082 0.865375 21.0082C1.07133 21.0082 1.29182 20.9298 1.4485 20.7724L10.5378 11.683L19.6231 20.7732C19.7798 20.9307 19.9882 21.009 20.1934 21.009C20.3985 21.009 20.6061 20.9307 20.7628 20.7732C21.0769 20.459 21.0777 19.9494 20.7636 19.6352L11.6823 10.5442Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                </div>
                {modalCompareVersion &&
                  itemsVersionsForCompare &&
                  itemsVersionsForCompare.length > 0 &&
                  itemsVersionsForCompare && (
                    <CompareVersion
                      itemSelected={itemSelected}
                      itemsVersionsForCompare={itemsVersionsForCompare}
                      workclient={workclient}
                      viewerCompare={viewerCompare}
                    />
                  )}
                <div
                  className="bb-modal__archive-grid-button"
                  style={{ display: "none" }}
                >
                  <div className="bb-modal__archive-button soundOff">
                    <span>
                      <svg
                        width={28}
                        height={26}
                        viewBox="0 0 28 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="11.2" height={26} rx={2} fill="white" />
                        <rect
                          x="16.8003"
                          width="11.2"
                          height={26}
                          rx={2}
                          fill="white"
                        />
                      </svg>
                    </span>
                    <span className="soundOff">
                      <svg
                        width={28}
                        height={27}
                        viewBox="0 0 28 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6.38617 7.64151H2.22026C0.994046 7.64151 0 8.66788 0 9.93396V17.066C0 18.3321 0.994046 19.3585 2.22026 19.3585H6.38617L18.2555 27V0L6.38617 7.64151ZM20.8159 9.7757C21.1049 9.47728 21.5735 9.47728 21.8625 9.7757L24.2996 12.292L26.7366 9.7757C27.0256 9.47728 27.4942 9.47728 27.7832 9.7757C28.0723 10.0741 28.0723 10.558 27.7832 10.8564L25.3462 13.3726L27.7832 15.8889C28.0723 16.1873 28.0723 16.6712 27.7832 16.9696C27.4942 17.268 27.0256 17.268 26.7366 16.9696L24.2996 14.4533L21.8625 16.9696C21.5735 17.268 21.1049 17.268 20.8159 16.9696C20.5269 16.6712 20.5269 16.1873 20.8159 15.8889L23.2529 13.3726L20.8159 10.8564C20.5269 10.558 20.5269 10.0741 20.8159 9.7757Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                    <span className="soundOn">
                      <svg
                        width={28}
                        height={27}
                        viewBox="0 0 28 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.23009 7.64151H6.41443L18.3363 0V27L6.41443 19.3585H2.23009C0.998445 19.3585 0 18.3321 0 17.066V9.93396C0 8.66788 0.998445 7.64151 2.23009 7.64151Z"
                          fill="white"
                        />
                        <path
                          d="M28 13.6272C28 18.1579 24.9314 21.9518 20.8142 22.9327V21.3553C24.1018 20.4104 26.5133 17.3083 26.5133 13.6272C26.5133 9.94609 24.1018 6.84397 20.8142 5.89912V4.32173C24.9314 5.30256 28 9.0965 28 13.6272Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
              <div
                className="bb-modal__editarchive"
                onBlur={this.closeAll}
                tabIndex="1"
              >
                <a className="close-editarchive" href={hash}>
                  <svg
                    width={21}
                    height={22}
                    viewBox="0 0 21 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.75942 7.89313C6.91611 8.05062 7.12206 8.12896 7.32801 8.12896C7.53396 8.12896 7.73991 8.05062 7.8966 7.89313C8.21078 7.57895 8.21078 7.06932 7.8966 6.75514L1.46363 0.315711C1.14945 0.00153374 0.640631 0.00153374 0.326454 0.315711C0.0122759 0.629889 0.0122759 1.13952 0.326454 1.4537L6.75942 7.89313Z"
                      fill="white"
                    />
                    <path
                      d="M11.6823 10.5442L20.7644 1.45406C21.0785 1.13989 21.0785 0.630257 20.7644 0.316079C20.4502 0.00190138 19.9414 -0.137015 19.6272 0.17797L9.97733 9.69779H9.73827V9.97643L0.207944 19.6344C-0.106233 19.9485 -0.046467 20.4582 0.266903 20.7724C0.423588 20.9298 0.659423 21.0082 0.865375 21.0082C1.07133 21.0082 1.29182 20.9298 1.4485 20.7724L10.5378 11.683L19.6231 20.7732C19.7798 20.9307 19.9882 21.009 20.1934 21.009C20.3985 21.009 20.6061 20.9307 20.7628 20.7732C21.0769 20.459 21.0777 19.9494 20.7636 19.6352L11.6823 10.5442Z"
                      fill="white"
                    />
                  </svg>
                </a>
                <div className="bb-modal__editarchive-top">
                  <figure>
                    <svg
                      width={59}
                      height={44}
                      viewBox="0 0 59 44"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        y="0.738281"
                        width={59}
                        height="42.5225"
                        rx="7.97297"
                        fill="#5167DD"
                      />
                      <path
                        d="M34.1908 21.234L24.9421 15.7294C24.8292 15.6629 24.7129 15.623 24.58 15.623C24.2179 15.623 23.9223 15.922 23.9223 16.2875H23.9189V27.7154H23.9223C23.9223 28.0808 24.2179 28.3798 24.58 28.3798C24.7162 28.3798 24.8292 28.3333 24.9521 28.2669L34.1908 22.7688C34.41 22.5861 34.5496 22.3104 34.5496 22.0014C34.5496 21.6925 34.41 21.4201 34.1908 21.234Z"
                        fill="white"
                      />
                    </svg>
                  </figure>
                  <h3>Nombre del archivo elegido</h3>
                </div>
                <div className="bb-modal__editarchive-data">
                  <ul>
                    <li>12:00</li>
                    <li>12/09/2021</li>
                    <li>versión: 3</li>
                  </ul>
                </div>
                <div className="bb-modal__editarchive-tags">
                  <h3>Tags heredados de la versión anterior</h3>
                  <div className="bb-modal__editarchive-items">
                    <a className="bb-modal__editarchive-item" href={hash}>
                      Nombre tag
                      <span>
                        <svg
                          width={9}
                          height={9}
                          viewBox="0 0 9 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.87732 3.36051C2.94401 3.42754 3.03166 3.46088 3.11932 3.46088C3.20698 3.46088 3.29463 3.42754 3.36132 3.36051C3.49504 3.22679 3.49504 3.00988 3.36132 2.87616L0.623352 0.135445C0.489633 0.00172657 0.27307 0.00172657 0.139352 0.135445C0.00563282 0.269164 0.00563282 0.48607 0.139352 0.619789L2.87732 3.36051Z"
                            fill="#535361"
                          />
                          <path
                            d="M4.97216 4.48778L8.83763 0.618872C8.97135 0.485153 8.97135 0.268247 8.83763 0.134528C8.70391 0.000809258 8.48735 -0.0583157 8.35363 0.0757468L4.2465 4.12753H4.14475V4.24612L0.0885042 8.35668C-0.0452146 8.4904 -0.0197771 8.70731 0.113598 8.84103C0.180285 8.90806 0.28066 8.9414 0.368317 8.9414C0.455973 8.9414 0.549817 8.90806 0.616504 8.84103L4.48507 4.97247L8.35191 8.84137C8.4186 8.9084 8.50729 8.94175 8.5946 8.94175C8.68191 8.94175 8.77025 8.9084 8.83694 8.84137C8.97066 8.70765 8.971 8.49075 8.83729 8.35703L4.97216 4.48778Z"
                            fill="#535361"
                          />
                        </svg>
                      </span>
                    </a>
                    <a className="bb-modal__editarchive-item" href={hash}>
                      Nombre tag
                      <span>
                        <svg
                          width={9}
                          height={9}
                          viewBox="0 0 9 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.87732 3.36051C2.94401 3.42754 3.03166 3.46088 3.11932 3.46088C3.20698 3.46088 3.29463 3.42754 3.36132 3.36051C3.49504 3.22679 3.49504 3.00988 3.36132 2.87616L0.623352 0.135445C0.489633 0.00172657 0.27307 0.00172657 0.139352 0.135445C0.00563282 0.269164 0.00563282 0.48607 0.139352 0.619789L2.87732 3.36051Z"
                            fill="#535361"
                          />
                          <path
                            d="M4.97216 4.48778L8.83763 0.618872C8.97135 0.485153 8.97135 0.268247 8.83763 0.134528C8.70391 0.000809258 8.48735 -0.0583157 8.35363 0.0757468L4.2465 4.12753H4.14475V4.24612L0.0885042 8.35668C-0.0452146 8.4904 -0.0197771 8.70731 0.113598 8.84103C0.180285 8.90806 0.28066 8.9414 0.368317 8.9414C0.455973 8.9414 0.549817 8.90806 0.616504 8.84103L4.48507 4.97247L8.35191 8.84137C8.4186 8.9084 8.50729 8.94175 8.5946 8.94175C8.68191 8.94175 8.77025 8.9084 8.83694 8.84137C8.97066 8.70765 8.971 8.49075 8.83729 8.35703L4.97216 4.48778Z"
                            fill="#535361"
                          />
                        </svg>
                      </span>
                    </a>
                    <a className="bb-modal__editarchive-item" href={hash}>
                      Nombre tag
                      <span>
                        <svg
                          width={9}
                          height={9}
                          viewBox="0 0 9 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.87732 3.36051C2.94401 3.42754 3.03166 3.46088 3.11932 3.46088C3.20698 3.46088 3.29463 3.42754 3.36132 3.36051C3.49504 3.22679 3.49504 3.00988 3.36132 2.87616L0.623352 0.135445C0.489633 0.00172657 0.27307 0.00172657 0.139352 0.135445C0.00563282 0.269164 0.00563282 0.48607 0.139352 0.619789L2.87732 3.36051Z"
                            fill="#535361"
                          />
                          <path
                            d="M4.97216 4.48778L8.83763 0.618872C8.97135 0.485153 8.97135 0.268247 8.83763 0.134528C8.70391 0.000809258 8.48735 -0.0583157 8.35363 0.0757468L4.2465 4.12753H4.14475V4.24612L0.0885042 8.35668C-0.0452146 8.4904 -0.0197771 8.70731 0.113598 8.84103C0.180285 8.90806 0.28066 8.9414 0.368317 8.9414C0.455973 8.9414 0.549817 8.90806 0.616504 8.84103L4.48507 4.97247L8.35191 8.84137C8.4186 8.9084 8.50729 8.94175 8.5946 8.94175C8.68191 8.94175 8.77025 8.9084 8.83694 8.84137C8.97066 8.70765 8.971 8.49075 8.83729 8.35703L4.97216 4.48778Z"
                            fill="#535361"
                          />
                        </svg>
                      </span>
                    </a>
                    <a className="bb-modal__editarchive-item" href={hash}>
                      Nombre tag
                      <span>
                        <svg
                          width={9}
                          height={9}
                          viewBox="0 0 9 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.87732 3.36051C2.94401 3.42754 3.03166 3.46088 3.11932 3.46088C3.20698 3.46088 3.29463 3.42754 3.36132 3.36051C3.49504 3.22679 3.49504 3.00988 3.36132 2.87616L0.623352 0.135445C0.489633 0.00172657 0.27307 0.00172657 0.139352 0.135445C0.00563282 0.269164 0.00563282 0.48607 0.139352 0.619789L2.87732 3.36051Z"
                            fill="#535361"
                          />
                          <path
                            d="M4.97216 4.48778L8.83763 0.618872C8.97135 0.485153 8.97135 0.268247 8.83763 0.134528C8.70391 0.000809258 8.48735 -0.0583157 8.35363 0.0757468L4.2465 4.12753H4.14475V4.24612L0.0885042 8.35668C-0.0452146 8.4904 -0.0197771 8.70731 0.113598 8.84103C0.180285 8.90806 0.28066 8.9414 0.368317 8.9414C0.455973 8.9414 0.549817 8.90806 0.616504 8.84103L4.48507 4.97247L8.35191 8.84137C8.4186 8.9084 8.50729 8.94175 8.5946 8.94175C8.68191 8.94175 8.77025 8.9084 8.83694 8.84137C8.97066 8.70765 8.971 8.49075 8.83729 8.35703L4.97216 4.48778Z"
                            fill="#535361"
                          />
                        </svg>
                      </span>
                    </a>
                    <a className="bb-modal__editarchive-item" href={hash}>
                      Nombre tag
                      <span>
                        <svg
                          width={9}
                          height={9}
                          viewBox="0 0 9 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.87732 3.36051C2.94401 3.42754 3.03166 3.46088 3.11932 3.46088C3.20698 3.46088 3.29463 3.42754 3.36132 3.36051C3.49504 3.22679 3.49504 3.00988 3.36132 2.87616L0.623352 0.135445C0.489633 0.00172657 0.27307 0.00172657 0.139352 0.135445C0.00563282 0.269164 0.00563282 0.48607 0.139352 0.619789L2.87732 3.36051Z"
                            fill="#535361"
                          />
                          <path
                            d="M4.97216 4.48778L8.83763 0.618872C8.97135 0.485153 8.97135 0.268247 8.83763 0.134528C8.70391 0.000809258 8.48735 -0.0583157 8.35363 0.0757468L4.2465 4.12753H4.14475V4.24612L0.0885042 8.35668C-0.0452146 8.4904 -0.0197771 8.70731 0.113598 8.84103C0.180285 8.90806 0.28066 8.9414 0.368317 8.9414C0.455973 8.9414 0.549817 8.90806 0.616504 8.84103L4.48507 4.97247L8.35191 8.84137C8.4186 8.9084 8.50729 8.94175 8.5946 8.94175C8.68191 8.94175 8.77025 8.9084 8.83694 8.84137C8.97066 8.70765 8.971 8.49075 8.83729 8.35703L4.97216 4.48778Z"
                            fill="#535361"
                          />
                        </svg>
                      </span>
                    </a>
                    <a className="bb-modal__editarchive-item" href={hash}>
                      Nombre tag
                      <span>
                        <svg
                          width={9}
                          height={9}
                          viewBox="0 0 9 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.87732 3.36051C2.94401 3.42754 3.03166 3.46088 3.11932 3.46088C3.20698 3.46088 3.29463 3.42754 3.36132 3.36051C3.49504 3.22679 3.49504 3.00988 3.36132 2.87616L0.623352 0.135445C0.489633 0.00172657 0.27307 0.00172657 0.139352 0.135445C0.00563282 0.269164 0.00563282 0.48607 0.139352 0.619789L2.87732 3.36051Z"
                            fill="#535361"
                          />
                          <path
                            d="M4.97216 4.48778L8.83763 0.618872C8.97135 0.485153 8.97135 0.268247 8.83763 0.134528C8.70391 0.000809258 8.48735 -0.0583157 8.35363 0.0757468L4.2465 4.12753H4.14475V4.24612L0.0885042 8.35668C-0.0452146 8.4904 -0.0197771 8.70731 0.113598 8.84103C0.180285 8.90806 0.28066 8.9414 0.368317 8.9414C0.455973 8.9414 0.549817 8.90806 0.616504 8.84103L4.48507 4.97247L8.35191 8.84137C8.4186 8.9084 8.50729 8.94175 8.5946 8.94175C8.68191 8.94175 8.77025 8.9084 8.83694 8.84137C8.97066 8.70765 8.971 8.49075 8.83729 8.35703L4.97216 4.48778Z"
                            fill="#535361"
                          />
                        </svg>
                      </span>
                    </a>
                    <a className="bb-modal__editarchive-item" href={hash}>
                      Nombre tag
                      <span>
                        <svg
                          width={9}
                          height={9}
                          viewBox="0 0 9 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.87732 3.36051C2.94401 3.42754 3.03166 3.46088 3.11932 3.46088C3.20698 3.46088 3.29463 3.42754 3.36132 3.36051C3.49504 3.22679 3.49504 3.00988 3.36132 2.87616L0.623352 0.135445C0.489633 0.00172657 0.27307 0.00172657 0.139352 0.135445C0.00563282 0.269164 0.00563282 0.48607 0.139352 0.619789L2.87732 3.36051Z"
                            fill="#535361"
                          />
                          <path
                            d="M4.97216 4.48778L8.83763 0.618872C8.97135 0.485153 8.97135 0.268247 8.83763 0.134528C8.70391 0.000809258 8.48735 -0.0583157 8.35363 0.0757468L4.2465 4.12753H4.14475V4.24612L0.0885042 8.35668C-0.0452146 8.4904 -0.0197771 8.70731 0.113598 8.84103C0.180285 8.90806 0.28066 8.9414 0.368317 8.9414C0.455973 8.9414 0.549817 8.90806 0.616504 8.84103L4.48507 4.97247L8.35191 8.84137C8.4186 8.9084 8.50729 8.94175 8.5946 8.94175C8.68191 8.94175 8.77025 8.9084 8.83694 8.84137C8.97066 8.70765 8.971 8.49075 8.83729 8.35703L4.97216 4.48778Z"
                            fill="#535361"
                          />
                        </svg>
                      </span>
                    </a>
                    <a className="bb-modal__editarchive-item" href={hash}>
                      Nombre tag
                      <span>
                        <svg
                          width={9}
                          height={9}
                          viewBox="0 0 9 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.87732 3.36051C2.94401 3.42754 3.03166 3.46088 3.11932 3.46088C3.20698 3.46088 3.29463 3.42754 3.36132 3.36051C3.49504 3.22679 3.49504 3.00988 3.36132 2.87616L0.623352 0.135445C0.489633 0.00172657 0.27307 0.00172657 0.139352 0.135445C0.00563282 0.269164 0.00563282 0.48607 0.139352 0.619789L2.87732 3.36051Z"
                            fill="#535361"
                          />
                          <path
                            d="M4.97216 4.48778L8.83763 0.618872C8.97135 0.485153 8.97135 0.268247 8.83763 0.134528C8.70391 0.000809258 8.48735 -0.0583157 8.35363 0.0757468L4.2465 4.12753H4.14475V4.24612L0.0885042 8.35668C-0.0452146 8.4904 -0.0197771 8.70731 0.113598 8.84103C0.180285 8.90806 0.28066 8.9414 0.368317 8.9414C0.455973 8.9414 0.549817 8.90806 0.616504 8.84103L4.48507 4.97247L8.35191 8.84137C8.4186 8.9084 8.50729 8.94175 8.5946 8.94175C8.68191 8.94175 8.77025 8.9084 8.83694 8.84137C8.97066 8.70765 8.971 8.49075 8.83729 8.35703L4.97216 4.48778Z"
                            fill="#535361"
                          />
                        </svg>
                      </span>
                    </a>
                    <a className="bb-modal__editarchive-item" href={hash}>
                      Nombre tag
                      <span>
                        <svg
                          width={9}
                          height={9}
                          viewBox="0 0 9 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.87732 3.36051C2.94401 3.42754 3.03166 3.46088 3.11932 3.46088C3.20698 3.46088 3.29463 3.42754 3.36132 3.36051C3.49504 3.22679 3.49504 3.00988 3.36132 2.87616L0.623352 0.135445C0.489633 0.00172657 0.27307 0.00172657 0.139352 0.135445C0.00563282 0.269164 0.00563282 0.48607 0.139352 0.619789L2.87732 3.36051Z"
                            fill="#535361"
                          />
                          <path
                            d="M4.97216 4.48778L8.83763 0.618872C8.97135 0.485153 8.97135 0.268247 8.83763 0.134528C8.70391 0.000809258 8.48735 -0.0583157 8.35363 0.0757468L4.2465 4.12753H4.14475V4.24612L0.0885042 8.35668C-0.0452146 8.4904 -0.0197771 8.70731 0.113598 8.84103C0.180285 8.90806 0.28066 8.9414 0.368317 8.9414C0.455973 8.9414 0.549817 8.90806 0.616504 8.84103L4.48507 4.97247L8.35191 8.84137C8.4186 8.9084 8.50729 8.94175 8.5946 8.94175C8.68191 8.94175 8.77025 8.9084 8.83694 8.84137C8.97066 8.70765 8.971 8.49075 8.83729 8.35703L4.97216 4.48778Z"
                            fill="#535361"
                          />
                        </svg>
                      </span>
                    </a>
                  </div>
                </div>
                <div className="bb-modal__editarchive-actions">
                  <div className="bb-modal__editarchive-input">
                    <input type="text" placeholder="Agregar Tag" />
                  </div>
                  <a className="bb-modal__editarchive-save" href={hash}>
                    Guardar
                  </a>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="loading-dart">
            <ClipLoader
              loading={true}
              size={SIZE_LOADER}
              color={COLOR_LOADER}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const obj = {
    itemSelected: state.comments.itemSelected,
    itemSelectedFetching: state.comments.itemSelectedFetching,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    width: state.app.width,
    versionsShowCompare: state.comments.versionsShowCompare,
    showVersions: state.comments.showVersions,
    user: state.authUser.user,
    newMatrix: state.group.newMatrix,
    breadcrumb: state.client.breadcrumb,
    workclient: state.client.workclient,
    isFetching: state.comments.itemSelectedFetching,
    itemVersions: state.comments.itemVersions,
    isUpdating: state.assetsRoot.isUpdating,
    loadingDescription: state.comments.loadingDescription,
    loadingStatusAsset: state.comments.loadingStatusAsset,
    loadingItemsMedia: state.comments.loadingItemsMedia,
    userDefaultComments: state.comments.userDefaultComments,
    dartCustomField: state.client.data ? state.client.data.dartCustomField : [],
    fromKeyCollection: state.comments.fromKeyCollection,
    clientId: state.client.data ? state.client.data._id : null,
    media: state.client.data ? state.client.data.media : null,
    statusAsset: state.client.data ? state.client.data.statusAsset : [],
    focusDescription: state.comments.focusDescription,
    adminUsersToComment: state.comments.adminUsersToComment,
    operatorsUsersToComment: state.comments.operatorsUsersToComment,
    isFetchingUsersToComment: state.comments.isFetchingUsersToComment,
    isDoingACommentWithFile: state.comments.isDoingACommentWithFile,
    isPdfTagActive: state.comments.isPdfTagActive,
    isAudioTagActive: state.comments.isAudioTagActive,
    isImageTagActive: state.comments.isImageTagActive,
    imageTagXPer: state.comments.imageTagXPer,
    imageTagYPer: state.comments.imageTagYPer,
    imageTagWidth: state.comments.imageTagWidth,
    imageTagHeight: state.comments.imageTagHeight,
    imagePoint: state.comments.imagePoint,
    imageTagClicked: state.comments.imageTagClicked
  };

  switch (obj.fromKeyCollection) {
    case "assetsRoot":
      return {
        ...obj,
        data: state.assetsRoot.data
      };

    case "assetsLastUploads":
      return {
        ...obj,
        data: state.assetsLastUploads.data
      };

    case "assetsShared":
      return {
        ...obj,
        data: state.assetsShared.data
      };

    case "assetsFavorites":
      return {
        ...obj,
        data: state.assetsFavorites.data
      };

    case "assetsExplore":
      return {
        ...obj,
        data: state.assetsExplore.data
      };

    case "searcher":
      return {
        ...obj,
        data: state.searcher.data
      };

    default:
      return {
        ...obj,
        data: []
      };
  }
};

const mapDispatchToProps = {
  hideComment,
  consultCommentDetermined,
  showHideVersions,
  hideVersions,
  handleShowHideEmoji,
  getSearchResult,
  getClientsByName,
  createComment,
  getComments,
  swapVersion,
  setEditAsset,
  showComment,
  showCompareVersions,
  hideVersionsAndCompareVersions,
  setSelectItem,
  setSelectedItem,
  deleteCommentDetermined,
  saveCommentDetermined,
  handleShowNewVersionAsset,
  updateClientes,
  deleteVersions,
  createClientMedia,
  createClientStatus,
  deleteClientMedia,
  deleteClientStatus,
  deleteComment,
  clearFocusDecription,
  updateComment,
  setPDFCarouselIndex,
  unsetIsPdfTagActive,
  unsetIsImageTagActive,
  unsetIsVideoTagActive,
  unsetIsAudioTagActive,
  checkAsset,
  showVersionHasChangedMessage,
  setIsImageTagActive
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Main2))
);
